import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "change-log",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#change-log",
        "aria-label": "change log permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Change Log`}</h1>
    <h2 {...{
      "id": "11330",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11330",
        "aria-label": "11330 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.33.0`}</h2>
    <h3 {...{
      "id": "minor-changes",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#minor-changes",
        "aria-label": "minor changes permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Minor Changes`}</h3>
    <ul>
      <li parentName="ul">{`aeffbec3b6: Breadcrumb variant="list" added for preferred list markup`}</li>
      <li parentName="ul">{`a2add226a0: export type DropdownItemProps`}</li>
    </ul>
    <h2 {...{
      "id": "11320",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11320",
        "aria-label": "11320 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.32.0`}</h2>
    <h3 {...{
      "id": "minor-changes-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#minor-changes-1",
        "aria-label": "minor changes 1 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Minor Changes`}</h3>
    <ul>
      <li parentName="ul">{`eda95ac08e: Changing Tabs colors, spacing, to match helix designs`}</li>
      <li parentName="ul">{`2aa913ec90: Slight updates to Page for helix padding`}</li>
      <li parentName="ul">{`2b3c589b90: Reduces dependency on `}<inlineCode parentName="li">{`formik`}</inlineCode>{` by replacing unnecessary `}<inlineCode parentName="li">{`isFunction`}</inlineCode>{` imports.`}</li>
    </ul>
    <h2 {...{
      "id": "11311",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11311",
        "aria-label": "11311 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.31.1`}</h2>
    <h3 {...{
      "id": "patch-changes",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes",
        "aria-label": "patch changes permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`ab612d7197: jsDoc comments moved to re-export level for components`}</li>
      <li parentName="ul">{`9afd509e6e: jsDoc comments moved to re-export level for components`}</li>
    </ul>
    <h2 {...{
      "id": "11310",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11310",
        "aria-label": "11310 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.31.0`}</h2>
    <h3 {...{
      "id": "minor-changes-2",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#minor-changes-2",
        "aria-label": "minor changes 2 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Minor Changes`}</h3>
    <ul>
      <li parentName="ul">{`cab8101db6: Standardize Locale type to the officially supported locale list. Add export function getI18nProviderLocale to transform environemnt Locale to officially supported fallback.`}</li>
    </ul>
    <h3 {...{
      "id": "patch-changes-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-1",
        "aria-label": "patch changes 1 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`Updated dependencies `}{`[cab8101db6]`}
        <ul parentName="li">
          <li parentName="ul">{`@procore/`}<a parentName="li" {...{
              "href": "mailto:core-i18n-js@10.28.0",
              "target": "_blank",
              "rel": "nofollow noopener noreferrer"
            }}>{`core-i18n-js@10.28.0`}</a></li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "11300",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11300",
        "aria-label": "11300 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.30.0`}</h2>
    <h3 {...{
      "id": "minor-changes-3",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#minor-changes-3",
        "aria-label": "minor changes 3 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Minor Changes`}</h3>
    <ul>
      <li parentName="ul">{`afda078f68: adds overlayMatchesTriggerWidth:false prop to set select menu width to 360px`}</li>
    </ul>
    <h3 {...{
      "id": "patch-changes-2",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-2",
        "aria-label": "patch changes 2 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`26f33e7caa: update versions of react aria focus (3.16.2), internations (3.21.1), utils (3.23.2)`}</li>
    </ul>
    <h2 {...{
      "id": "11290",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11290",
        "aria-label": "11290 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.29.0`}</h2>
    <h3 {...{
      "id": "minor-changes-4",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#minor-changes-4",
        "aria-label": "minor changes 4 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Minor Changes`}</h3>
    <ul>
      <li parentName="ul">{`6081ae6346: `}<inlineCode parentName="li">{`Table.CurrencyCell`}</inlineCode>{` formats currency with `}<inlineCode parentName="li">{`value`}</inlineCode>{` and `}<inlineCode parentName="li">{`currencyOptions`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "patch-changes-3",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-3",
        "aria-label": "patch changes 3 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`e4364b4d00: Fixing a bug in iOS rendering for panel footer`}</li>
      <li parentName="ul">{`646df7b4c5: Fix `}<inlineCode parentName="li">{`Banner.Action`}</inlineCode>{` to properly style `}<inlineCode parentName="li">{`LinkButton`}</inlineCode>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "11280",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11280",
        "aria-label": "11280 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.28.0`}</h2>
    <h3 {...{
      "id": "minor-changes-5",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#minor-changes-5",
        "aria-label": "minor changes 5 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Minor Changes`}</h3>
    <ul>
      <li parentName="ul">{`replace Form.Checkbox read state text with icons; make them readable by screen reader`}</li>
    </ul>
    <h2 {...{
      "id": "11270",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11270",
        "aria-label": "11270 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.27.0`}</h2>
    <h3 {...{
      "id": "minor-changes-6",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#minor-changes-6",
        "aria-label": "minor changes 6 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Minor Changes`}</h3>
    <ul>
      <li parentName="ul">{`7e8828c353: allow LinkButton role="link"`}</li>
    </ul>
    <h3 {...{
      "id": "patch-changes-4",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-4",
        "aria-label": "patch changes 4 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`da25e80a4d: Menu CSS inherits border radius down to Menu.Footer. fixes background color change overflow`}</li>
      <li parentName="ul">{`8fb7849a4f: fix LinkButton assure no underline on hover`}</li>
      <li parentName="ul">{`Menu inherits border radius down to Footer, fixes background color overflow`}</li>
    </ul>
    <h2 {...{
      "id": "11262",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11262",
        "aria-label": "11262 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.26.2`}</h2>
    <h3 {...{
      "id": "patch-changes-5",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-5",
        "aria-label": "patch changes 5 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`c6d4699736: Update JSDoc Storybook links`}</li>
    </ul>
    <h2 {...{
      "id": "11261",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11261",
        "aria-label": "11261 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.26.1`}</h2>
    <h3 {...{
      "id": "patch-changes-6",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-6",
        "aria-label": "patch changes 6 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`46ad754d7e: Modify Form.MultiSelect to avoid flickering in React 18`}</li>
    </ul>
    <h2 {...{
      "id": "11260",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11260",
        "aria-label": "11260 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.26.0`}</h2>
    <h3 {...{
      "id": "minor-changes-7",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#minor-changes-7",
        "aria-label": "minor changes 7 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Minor Changes`}</h3>
    <ul>
      <li parentName="ul">{`Add a semantic `}<inlineCode parentName="li">{`OL`}</inlineCode>{` component`}</li>
      <li parentName="ul">{`e5bc443bbe: - `}<inlineCode parentName="li">{`InfoBanner`}</inlineCode>{` primary color was changed to `}<inlineCode parentName="li">{`blue50`}</inlineCode>
        <ul parentName="li">
          <li parentName="ul">{`Added `}<inlineCode parentName="li">{`AttentionBanner`}</inlineCode>{` and `}<inlineCode parentName="li">{`attention`}</inlineCode>{` variant`}</li>
          <li parentName="ul">{`Added deprecation of `}<inlineCode parentName="li">{`ActionBanner`}</inlineCode>{` and `}<inlineCode parentName="li">{`action`}</inlineCode>{` variant`}</li>
          <li parentName="ul">{`Replaced usages of `}<inlineCode parentName="li">{`ActionBanner`}</inlineCode>{` with `}<inlineCode parentName="li">{`AttentionBanner`}</inlineCode>{` in `}<inlineCode parentName="li">{`core-react`}</inlineCode>{` and `}<inlineCode parentName="li">{`core-docs`}</inlineCode>{`.`}</li>
          <li parentName="ul">{`Removed stories(variants of usage) that are not present in design (`}<inlineCode parentName="li">{`Buttons`}</inlineCode>{` and `}<inlineCode parentName="li">{`OnlyTitle `}</inlineCode>{`)`}</li>
        </ul>
      </li>
      <li parentName="ul">{`444a8142fa: - Added `}<inlineCode parentName="li">{`alignment`}</inlineCode>{` prop to `}<inlineCode parentName="li">{`Title.Assets`}</inlineCode>
        <ul parentName="li">
          <li parentName="ul">{`Added `}<inlineCode parentName="li">{`Base Layout`}</inlineCode>{` example to `}<inlineCode parentName="li">{`DetailPage`}</inlineCode>{` docs and storybook.`}</li>
          <li parentName="ul">{`Removed extra `}<inlineCode parentName="li">{`24px`}</inlineCode>{` margin for first `}<inlineCode parentName="li">{`Banner`}</inlineCode>{` and `}<inlineCode parentName="li">{`Page Title`}</inlineCode>{` in `}<inlineCode parentName="li">{`Body`}</inlineCode></li>
        </ul>
      </li>
    </ul>
    <h3 {...{
      "id": "patch-changes-7",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-7",
        "aria-label": "patch changes 7 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`c8654c8287: BugFix - Added isTierDisabled property function to context, this allows disabled tiers to show as disabled correctly if the property provided`}</li>
      <li parentName="ul">{`5e37c4cd2d: Link variant white hover color`}</li>
      <li parentName="ul">{`Updated dependencies `}{`[a147cbdd8a]`}
        <ul parentName="li">
          <li parentName="ul">{`@procore/`}<a parentName="li" {...{
              "href": "mailto:core-icons@12.0.0",
              "target": "_blank",
              "rel": "nofollow noopener noreferrer"
            }}>{`core-icons@12.0.0`}</a></li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "11252",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11252",
        "aria-label": "11252 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.25.2`}</h2>
    <h3 {...{
      "id": "patch-changes-8",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-8",
        "aria-label": "patch changes 8 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`dd2a0d2131: Add export `}<inlineCode parentName="li">{`borderRadius`}</inlineCode>{` and `}<inlineCode parentName="li">{`UNSAFE_getBorderRadius`}</inlineCode></li>
    </ul>
    <h2 {...{
      "id": "11251",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11251",
        "aria-label": "11251 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.25.1`}</h2>
    <h3 {...{
      "id": "patch-changes-9",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-9",
        "aria-label": "patch changes 9 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`0b579f7b1f: Add container prop to Select and OverlayTrigger components`}</li>
    </ul>
    <h2 {...{
      "id": "11250",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11250",
        "aria-label": "11250 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.25.0`}</h2>
    <h3 {...{
      "id": "minor-changes-8",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#minor-changes-8",
        "aria-label": "minor changes 8 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Minor Changes`}</h3>
    <ul>
      <li parentName="ul">{`288753bd8c: Allow Tree component to update expanded nodes when expanded prop changes`}</li>
      <li parentName="ul">{`288753bd8c: Allow Tree component to update selected nodes when selected prop changes`}</li>
      <li parentName="ul">{`40e6e5c21f: `}<inlineCode parentName="li">{`Form`}</inlineCode>{` - added `}<inlineCode parentName="li">{`description`}</inlineCode>{` prop for each Field
`}<inlineCode parentName="li">{`Form.Checkbox`}</inlineCode>{` - added `}<inlineCode parentName="li">{`inlineLabel`}</inlineCode>{` and `}<inlineCode parentName="li">{`inlineDescription`}</inlineCode>{` props. Changed read view text to "Selected" and "Deselected"
`}<inlineCode parentName="li">{`Checkbox`}</inlineCode>{` - fixed clicking the container empty space toggles the checkbox, `}<inlineCode parentName="li">{`label`}</inlineCode>{` no longer wraps the `}<inlineCode parentName="li">{`input`}</inlineCode>{`. Added `}<inlineCode parentName="li">{`requiredMark`}</inlineCode>{` and `}<inlineCode parentName="li">{`tooltip`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "patch-changes-10",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-10",
        "aria-label": "patch changes 10 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`288753bd8c: Fixed Tree component autoExpandParent to work when updated via ref`}</li>
    </ul>
    <h2 {...{
      "id": "11244",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11244",
        "aria-label": "11244 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.24.4`}</h2>
    <h3 {...{
      "id": "patch-changes-11",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-11",
        "aria-label": "patch changes 11 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`bd2c971c59: fixed form label bottom margin`}</li>
    </ul>
    <h2 {...{
      "id": "11243",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11243",
        "aria-label": "11243 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.24.3`}</h2>
    <h3 {...{
      "id": "patch-changes-12",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-12",
        "aria-label": "patch changes 12 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`ef3ce2c072: fixed NumberInput not handling "-" value correctly`}</li>
      <li parentName="ul">{`2b4c256bee: match banner error text size to spec`}</li>
    </ul>
    <h2 {...{
      "id": "11242",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11242",
        "aria-label": "11242 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.24.2`}</h2>
    <h3 {...{
      "id": "patch-changes-13",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-13",
        "aria-label": "patch changes 13 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`7580d9daf8: Fixes bug on Form.ErrorBanner where validation error would show for untouched fields. Now only shows runs validations on touched fields`}</li>
    </ul>
    <h2 {...{
      "id": "11241",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11241",
        "aria-label": "11241 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.24.1`}</h2>
    <h3 {...{
      "id": "patch-changes-14",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-14",
        "aria-label": "patch changes 14 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`87a07712e0: Fix more re-export warnings`}</li>
    </ul>
    <h2 {...{
      "id": "11240",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11240",
        "aria-label": "11240 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.24.0`}</h2>
    <h3 {...{
      "id": "minor-changes-9",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#minor-changes-9",
        "aria-label": "minor changes 9 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Minor Changes`}</h3>
    <ul>
      <li parentName="ul">{`b743a1d9b4: Deprecate File Select component.`}</li>
    </ul>
    <h3 {...{
      "id": "patch-changes-15",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-15",
        "aria-label": "patch changes 15 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`a1e4b45cbd: Add new icons`}</li>
      <li parentName="ul">{`b1837d7e05: Fix more re-export warnings`}</li>
      <li parentName="ul">{`Updated dependencies `}{`[a1e4b45cbd]`}
        <ul parentName="li">
          <li parentName="ul">{`@procore/`}<a parentName="li" {...{
              "href": "mailto:core-icons@11.2.0",
              "target": "_blank",
              "rel": "nofollow noopener noreferrer"
            }}>{`core-icons@11.2.0`}</a></li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "11234",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11234",
        "aria-label": "11234 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.23.4`}</h2>
    <h3 {...{
      "id": "patch-changes-16",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-16",
        "aria-label": "patch changes 16 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`95ad1aa132: Annotate type only exports with the "type" keyword so that Babel removes them`}</li>
    </ul>
    <h2 {...{
      "id": "11233",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11233",
        "aria-label": "11233 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.23.3`}</h2>
    <h3 {...{
      "id": "patch-changes-17",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-17",
        "aria-label": "patch changes 17 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`e1d5276766: dropdown flyout dispatch close only when open`}</li>
      <li parentName="ul">{`2803b47fe2: secure checkbox so switch doesnt jump`}</li>
      <li parentName="ul">{`e02d337549: fixed ResizeObserver loop completed with undelivered notifications error by updating floating-ui`}</li>
      <li parentName="ul">{`f0cf7a439d: SuperSelect - fixed search doesn't receive focus in modal components`}</li>
    </ul>
    <h2 {...{
      "id": "11232",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11232",
        "aria-label": "11232 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.23.2`}</h2>
    <h3 {...{
      "id": "patch-changes-18",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-18",
        "aria-label": "patch changes 18 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`f97e38385d: Bugfix, use of dist imports for styled components in lib breaks usage of components`}</li>
    </ul>
    <h2 {...{
      "id": "11231",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11231",
        "aria-label": "11231 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.23.1`}</h2>
    <h3 {...{
      "id": "patch-changes-19",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-19",
        "aria-label": "patch changes 19 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`c033278f41: Added `}<inlineCode parentName="li">{`container`}</inlineCode>{` prop to FileSelect-related components.`}</li>
      <li parentName="ul">{`Updated dependencies `}{`[52e378b0c3]`}
        <ul parentName="li">
          <li parentName="ul">{`@procore/`}<a parentName="li" {...{
              "href": "mailto:core-i18n-js@10.27.7",
              "target": "_blank",
              "rel": "nofollow noopener noreferrer"
            }}>{`core-i18n-js@10.27.7`}</a></li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "11230",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11230",
        "aria-label": "11230 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.23.0`}</h2>
    <h3 {...{
      "id": "minor-changes-10",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#minor-changes-10",
        "aria-label": "minor changes 10 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Minor Changes`}</h3>
    <ul>
      <li parentName="ul">{`e4fcef1910: Using babel to compile core-react instead of just tsc`}</li>
    </ul>
    <h2 {...{
      "id": "11221",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11221",
        "aria-label": "11221 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.22.1`}</h2>
    <h3 {...{
      "id": "patch-changes-20",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-20",
        "aria-label": "patch changes 20 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`ae3db0d14c: Fixing the issue with FileSelect when using Select All and clicking Attach button`}</li>
    </ul>
    <h2 {...{
      "id": "11220",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11220",
        "aria-label": "11220 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.22.0`}</h2>
    <h3 {...{
      "id": "minor-changes-11",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#minor-changes-11",
        "aria-label": "minor changes 11 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Minor Changes`}</h3>
    <ul>
      <li parentName="ul">{`68b36077b: Improve user experience when using the Select All feature in the FileSelect component`}</li>
    </ul>
    <h3 {...{
      "id": "patch-changes-21",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-21",
        "aria-label": "patch changes 21 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`a76091520: File select responsive fixes`}</li>
    </ul>
    <h2 {...{
      "id": "11210",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11210",
        "aria-label": "11210 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.21.0`}</h2>
    <h3 {...{
      "id": "minor-changes-12",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#minor-changes-12",
        "aria-label": "minor changes 12 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Minor Changes`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`ef1d149963: Exporting types and styles used in data table and consuming them`}</p>
        <p parentName="li">{`The required minimium version of `}<inlineCode parentName="p">{`@procore/core-react`}</inlineCode>{` has been bumped to `}<inlineCode parentName="p">{`11.21.0`}</inlineCode>{`. This is to accomodate removing `}<inlineCode parentName="p">{`dist/`}</inlineCode>{` imports from the package.`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "11200",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11200",
        "aria-label": "11200 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.20.0`}</h2>
    <h3 {...{
      "id": "minor-changes-13",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#minor-changes-13",
        "aria-label": "minor changes 13 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Minor Changes`}</h3>
    <ul>
      <li parentName="ul">{`72d48fedbc: Adding `}<inlineCode parentName="li">{`Select All`}</inlineCode>{` functionality to the FileSelect.GridSource.`}</li>
      <li parentName="ul">{`4519fb4323: Added date format locale support for pt-BR and ja-JP.`}</li>
    </ul>
    <h3 {...{
      "id": "patch-changes-22",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-22",
        "aria-label": "patch changes 22 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`c818387322: Remove shipped noise`}</li>
      <li parentName="ul">{`4692db4d50: Add responsive thumbnails`}</li>
      <li parentName="ul">{`50f39ab62d: fixed type aliases and docs`}</li>
      <li parentName="ul">{`d49cb6127f: Allow user to change variant of buttons in panel header actions`}</li>
    </ul>
    <h2 {...{
      "id": "11190-2023-07-12",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11190-2023-07-12",
        "aria-label": "11190 2023 07 12 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.19.0 (2023-07-12)`}</h2>
    <h3 {...{
      "id": "minor-changes-14",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#minor-changes-14",
        "aria-label": "minor changes 14 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Minor Changes`}</h3>
    <ul>
      <li parentName="ul">{`8f3ba70994: add responsive file select modal`}</li>
      <li parentName="ul">{`38771f5e8f: Adding the namespace property to styled components, with version indicators`}</li>
    </ul>
    <h2 {...{
      "id": "11181-2023-06-28",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11181-2023-06-28",
        "aria-label": "11181 2023 06 28 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.18.1 (2023-06-28)`}</h2>
    <h3 {...{
      "id": "patch-changes-23",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-23",
        "aria-label": "patch changes 23 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`4d9c96402f: Increase the file select side bar width to display longer text`}</li>
      <li parentName="ul">{`c9fb9d24d6: File Select on cancel will now trigger resets`}</li>
      <li parentName="ul">{`7997e0a3ad: Search merges event handler props`}</li>
    </ul>
    <h2 {...{
      "id": "11180-2023-06-16",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11180-2023-06-16",
        "aria-label": "11180 2023 06 16 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.18.0 (2023-06-16)`}</h2>
    <h3 {...{
      "id": "minor-changes-15",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#minor-changes-15",
        "aria-label": "minor changes 15 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Minor Changes`}</h3>
    <ul>
      <li parentName="ul">{`TextEditorOutput init customization`}</li>
    </ul>
    <h2 {...{
      "id": "11170-2023-06-12",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11170-2023-06-12",
        "aria-label": "11170 2023 06 12 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.17.0 (2023-06-12)`}</h2>
    <h3 {...{
      "id": "minor-changes-16",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#minor-changes-16",
        "aria-label": "minor changes 16 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Minor Changes`}</h3>
    <ul>
      <li parentName="ul">{`ae5ea8973e: adding UNSAFE orange pill variant`}</li>
      <li parentName="ul">{`b11b0304de: Adding in unsafe banner variant for onboarding`}</li>
      <li parentName="ul">{`e743993fcc: Creating an unsafe minibanner to be used in onboarding`}</li>
    </ul>
    <h2 {...{
      "id": "11162-2023-06-09",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11162-2023-06-09",
        "aria-label": "11162 2023 06 09 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.16.2 (2023-06-09)`}</h2>
    <h3 {...{
      "id": "patch-changes-24",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-24",
        "aria-label": "patch changes 24 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`45602a4193: fix: bump @procore/globalizatin-toolkit from v1.16.1 -> v2.0.0 to fix crashes with CurrencyInput in Safari due to lacking Intl.NumberFormat support`}</li>
    </ul>
    <h2 {...{
      "id": "11161-2023-06-02",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11161-2023-06-02",
        "aria-label": "11161 2023 06 02 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.16.1 (2023-06-02)`}</h2>
    <h3 {...{
      "id": "patch-changes-25",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-25",
        "aria-label": "patch changes 25 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`95fd657361: Use locale from I18nProvider when formatting values in NumberOutput`}</li>
    </ul>
    <h2 {...{
      "id": "11160-2023-05-22",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11160-2023-05-22",
        "aria-label": "11160 2023 05 22 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.16.0 (2023-05-22)`}</h2>
    <h3 {...{
      "id": "minor-changes-17",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#minor-changes-17",
        "aria-label": "minor changes 17 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Minor Changes`}</h3>
    <ul>
      <li parentName="ul">{`6faaadf753: Add Popover#beforeHide and Popover#beforeShow
Fix AvatarStack keyboard navigation`}</li>
    </ul>
    <h3 {...{
      "id": "patch-changes-26",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-26",
        "aria-label": "patch changes 26 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`292ca49cdf: fix duplicate aria attribute in table`}</li>
    </ul>
    <h2 {...{
      "id": "11150-2023-05-05",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11150-2023-05-05",
        "aria-label": "11150 2023 05 05 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.15.0 (2023-05-05)`}</h2>
    <h3 {...{
      "id": "minor-changes-18",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#minor-changes-18",
        "aria-label": "minor changes 18 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Minor Changes`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`0c95825a21: AvatarStack keyboard and screen reader support.`}</p>
        <ul parentName="li">
          <li parentName="ul">{`All Avatars labelled.`}</li>
          <li parentName="ul">{`Same mouse popover hover interactions. Focus does not move into popover.`}</li>
          <li parentName="ul">{`Non link and disabled links are role img (non clickable)`}</li>
          <li parentName="ul">{`Avatar with links in popovers are links themselves`}</li>
          <li parentName="ul">{`Overflow circle is a button that open the See All modal. Focus does not move into popover of the short list.`}</li>
          <li parentName="ul">{`Non clickable items still have a popover, the screen reader can open the popover even though not in regular tab flow`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`720848034b: added ability for Dropdown to restore focus per item`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`a1f5027a7f: - Deprecated `}<inlineCode parentName="p">{`Table.HeaderCell#sortable`}</inlineCode></p>
        <ul parentName="li">
          <li parentName="ul">{`Deprecated `}<inlineCode parentName="li">{`Table.HeaderCell#variant`}</inlineCode>{` "asc/desc" values`}</li>
          <li parentName="ul">{`Introduced `}<inlineCode parentName="li">{`Table.HeaderCell#sortOrder`}</inlineCode>{` and `}<inlineCode parentName="li">{`Table.HeaderCell#onSortOrderChange`}</inlineCode></li>
          <li parentName="ul">{`Improved `}<inlineCode parentName="li">{`Table.HeaderCell`}</inlineCode>{` accessibility according to the WAI-ARIA guidelines`}</li>
        </ul>
      </li>
    </ul>
    <h3 {...{
      "id": "patch-changes-27",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-27",
        "aria-label": "patch changes 27 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`45174b2919: fix: `}{`[UIF-3566]`}{` Menu Imperative Checkbox Item disabled styles`}</li>
      <li parentName="ul">{`c4a01826ca: TextEditor tinymce overflow menu increase zindex to be above Modal`}</li>
    </ul>
    <h2 {...{
      "id": "11141-2023-04-26",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11141-2023-04-26",
        "aria-label": "11141 2023 04 26 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.14.1 (2023-04-26)`}</h2>
    <h3 {...{
      "id": "patch-changes-28",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-28",
        "aria-label": "patch changes 28 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`c97b670184: Removes the node engines requirement.`}</li>
      <li parentName="ul">{`fb9fa4806e: Fix FileSelect X button closes. useCloseWithConfirm - allow to close without provider`}</li>
      <li parentName="ul">{`00900e32a3: fix Calendar component crashes when invalid data is received, end date before start date`}</li>
      <li parentName="ul">{`bf56db355a: Modal X button and Body scroll in TAB flow. Modal onClose preffered focus UX on Body`}</li>
      <li parentName="ul">{`Updated dependencies `}{`[c97b670184]`}
        <ul parentName="li">
          <li parentName="ul">{`@procore/`}<a parentName="li" {...{
              "href": "mailto:core-icons@11.1.6",
              "target": "_blank",
              "rel": "nofollow noopener noreferrer"
            }}>{`core-icons@11.1.6`}</a></li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "11140-2023-04-21",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11140-2023-04-21",
        "aria-label": "11140 2023 04 21 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`11.14.0 (2023-04-21)`}</h2>
    <h3 {...{
      "id": "minor-changes-19",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#minor-changes-19",
        "aria-label": "minor changes 19 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Minor Changes`}</h3>
    <ul>
      <li parentName="ul">{`add MenuImperative.Item#as prop (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/12780",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#12780`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/96457ee2ba42b3c4ddaf78ac7c3d3dea3b1bcf59",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`96457ee`}</a>{`)`}</li>
      <li parentName="ul">{`35bafeeefd: Version bumps`}</li>
    </ul>
    <h3 {...{
      "id": "patch-changes-29",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#patch-changes-29",
        "aria-label": "patch changes 29 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Patch Changes`}</h3>
    <ul>
      <li parentName="ul">{`[UIF-3436]`}{` Tooltip OverlayTrigger bug (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/12775",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#12775`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/30c6987e71665662423092b4f86308072729915a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`30c6987`}</a>{`)`}</li>
      <li parentName="ul">{`fix superselect z-index (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/12838",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#12838`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/40fc2686598fa591beb6ba82e1ef226bed369f06",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`40fc268`}</a>{`)`}</li>
      <li parentName="ul">{`Updated dependencies `}{`[35bafeeefd]`}
        <ul parentName="li">
          <li parentName="ul">{`@procore/`}<a parentName="li" {...{
              "href": "mailto:core-icons@11.1.5",
              "target": "_blank",
              "rel": "nofollow noopener noreferrer"
            }}>{`core-icons@11.1.5`}</a></li>
        </ul>
      </li>
    </ul>
    <p><strong parentName="p">{`Note:`}</strong>{` Version bump only for package @procore/core-react`}</p>
    <h2 {...{
      "id": "11130-2023-03-31",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11130-2023-03-31",
        "aria-label": "11130 2023 03 31 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@11.12.1...@procore/core-react@11.13.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`11.13.0`}</a>{` (2023-03-31)`}</h2>
    <h3 {...{
      "id": "bug-fixes",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes",
        "aria-label": "bug fixes permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Breadcrumb invald attributes (#12740)`}</li>
    </ul>
    <h3 {...{
      "id": "features",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features",
        "aria-label": "features permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Role dialog support for Modal, Tearsheet, Popover, OverlayTrigger. Non modal default (#12502)`}</li>
      <li parentName="ul">{`Form no value empty state has aria linked to label (#12727)`}</li>
    </ul>
    <h2 {...{
      "id": "11121-2023-03-27",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11121-2023-03-27",
        "aria-label": "11121 2023 03 27 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@11.12.0...@procore/core-react@11.12.1",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`11.12.1`}</a>{` (2023-03-27)`}</h2>
    <h3 {...{
      "id": "bug-fixes-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-1",
        "aria-label": "bug fixes 1 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Avatar role link announced as a link (#12683)`}</li>
    </ul>
    <h2 {...{
      "id": "11120-2023-03-15",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11120-2023-03-15",
        "aria-label": "11120 2023 03 15 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@11.11.0...@procore/core-react@11.12.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`11.12.0`}</a>{` (2023-03-15)`}</h2>
    <h3 {...{
      "id": "bug-fixes-2",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-2",
        "aria-label": "bug fixes 2 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`AvatarStack visible to screen reader (#12642)`}</li>
    </ul>
    <h3 {...{
      "id": "features-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-1",
        "aria-label": "features 1 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`UIF-2647 - Toast Text and Toast Dismiss (#12494)`}</li>
      <li parentName="ul">{`UIF-3173 Added as prop for Headings (#12599)`}</li>
    </ul>
    <h3 {...{
      "id": "internal",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#internal",
        "aria-label": "internal permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Internal`}</h3>
    <ul>
      <li parentName="ul">{`rework superselect filter preset (#12624)`}</li>
      <li parentName="ul">{`refactor implement gtk in DateInput segments (#12619)`}</li>
    </ul>
    <h2 {...{
      "id": "11110-2023-03-07",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11110-2023-03-07",
        "aria-label": "11110 2023 03 07 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@11.10.0...@procore/core-react@11.11.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`11.11.0`}</a>{` (2023-03-07)`}</h2>
    <h3 {...{
      "id": "bug-fixes-3",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-3",
        "aria-label": "bug fixes 3 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Dropzone increase text color contrast (#12501)`}</li>
      <li parentName="ul">{`UIF-3457 - FileSelect Thumbnail list double count on click (#12604)`}</li>
    </ul>
    <h3 {...{
      "id": "features-2",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-2",
        "aria-label": "features 2 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`TextEditorProvider features tabAsNavigation stickyHeader and optional toolbar plugins table image (#12352)`}</li>
      <li parentName="ul">{`UIF-3102 Modal or Tearsheet confirm close with unsaved Form data (#12391)`}</li>
    </ul>
    <h3 {...{
      "id": "internal-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#internal-1",
        "aria-label": "internal 1 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Internal`}</h3>
    <ul>
      <li parentName="ul">{`refactor use GTK when possible Calendar start of week (#12579)`}</li>
      <li parentName="ul">{`refactor datetime utils to use GTK datetimeformat (#12572)`}</li>
      <li parentName="ul">{`UIF-2771 improvements and unsafe exports of MenuImperative for location filter a11y in data-table (#12576)`}</li>
      <li parentName="ul">{`add SuperSelect#onOpenChange (#12600)`}</li>
    </ul>
    <h2 {...{
      "id": "11100-2023-02-27",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#11100-2023-02-27",
        "aria-label": "11100 2023 02 27 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@11.9.0...@procore/core-react@11.10.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`11.10.0`}</a>{` (2023-02-27)`}</h2>
    <h3 {...{
      "id": "features-3",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-3",
        "aria-label": "features 3 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`wrld-7264 CurrencyInput props currencyIsoCode and currencyDisplay (#12369)`}</li>
      <li parentName="ul">{`FormNumber read view suffix and FormCurrency read view iso props (#12509)`}</li>
      <li parentName="ul">{`UIF-3168 FileSelect added label for ProgressBar in Thumbnail (#12368)`}</li>
      <li parentName="ul">{`UIF-3183 FileSelect screen reader support for FileToken (#12381)`}</li>
    </ul>
    <h3 {...{
      "id": "internal-2",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#internal-2",
        "aria-label": "internal 2 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Internal`}</h3>
    <ul>
      <li parentName="ul">{`introduce SuperSelect#onScrollBottom (#12438)`}</li>
      <li parentName="ul">{`rework SuperSelect filter preset (#12433)`}</li>
    </ul>
    <h2 {...{
      "id": "1190-2023-02-10",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1190-2023-02-10",
        "aria-label": "1190 2023 02 10 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@11.8.0...@procore/core-react@11.9.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`11.9.0`}</a>{` (2023-02-10)`}</h2>
    <h3 {...{
      "id": "bug-fixes-4",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-4",
        "aria-label": "bug fixes 4 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`revert Form Required location outside of label (#12340)`}</li>
      <li parentName="ul">{`revert Form helper setValue default arg (#12339)`}</li>
      <li parentName="ul">{`OverlayTrigger set width on floating element. ResizeObserverse overflow console eror (#12365)`}</li>
      <li parentName="ul">{`File Select Thumbnail List Delete Buttons (#12366)`}</li>
      <li parentName="ul">{`Pass onFocus onBlur to useButton Avatar and Tabs Tab (#12301)`}</li>
      <li parentName="ul">{`UIF-3270 resolve visual issues for Thumbnail states (#12297)`}</li>
      <li parentName="ul">{`patch Menu Dropdown double visual focus (#12373)`}</li>
    </ul>
    <h3 {...{
      "id": "features-4",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-4",
        "aria-label": "features 4 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Allow multiple Tree root nodes (#12241)`}</li>
      <li parentName="ul">{`Avatar focus state update (#12353)`}</li>
      <li parentName="ul">{`UIF-2724 FileSelect Total Progress Screen Reader Announcement (#12194)`}</li>
      <li parentName="ul">{`UIF-2638 Focus Not Obscured with Sticky Footers (#12222)`}</li>
    </ul>
    <h2 {...{
      "id": "1180-2023-01-27",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1180-2023-01-27",
        "aria-label": "1180 2023 01 27 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@11.7.0...@procore/core-react@11.8.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`11.8.0`}</a>{` (2023-01-27)`}</h2>
    <h3 {...{
      "id": "bug-fixes-5",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-5",
        "aria-label": "bug fixes 5 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`TieredSelect and Modals focus in / esc close (#12229)`}</li>
      <li parentName="ul">{`Thumbnail and Token a11y updates (#12214)`}</li>
      <li parentName="ul">{`Update Page window matchMedia test fix (#12254)`}</li>
    </ul>
    <h3 {...{
      "id": "features-5",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-5",
        "aria-label": "features 5 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Form Field Tooltip accessible (#12217)`}</li>
      <li parentName="ul">{`Label and Typography intent label (#12198)`}</li>
      <li parentName="ul">{`UIF-2724 ProgressBar aria-valuetext function and div props like id (#12155)`}</li>
      <li parentName="ul">{`UIF-3154 Page and DetailPage as prop support (#12242)`}</li>
    </ul>
    <h3 {...{
      "id": "internal-3",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#internal-3",
        "aria-label": "internal 3 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Internal`}</h3>
    <ul>
      <li parentName="ul">{`feat: UIF-2721 UIF-2780 SuperSelect Custom Component framework (#12101)`}</li>
    </ul>
    <h2 {...{
      "id": "1170-2023-1-13",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1170-2023-1-13",
        "aria-label": "1170 2023 1 13 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@11.6.0...@procore/core-react@11.7.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`11.7.0`}</a>{` (2023-1-13)`}</h2>
    <h3 {...{
      "id": "bug-fixes-6",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-6",
        "aria-label": "bug fixes 6 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`DropdownFlyout onclick (#12181)`}</li>
      <li parentName="ul">{`Modal and Tearsheet close button aria i18n (#12216)`}</li>
      <li parentName="ul">{`useDelayedCallback - not call after if component is unmounted (#12200)`}</li>
    </ul>
    <h3 {...{
      "id": "features-6",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-6",
        "aria-label": "features 6 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`UIF-2936 - Modal onClose opts-in for Esc to Close and dialog-like focus management (#11967)`}</li>
      <li parentName="ul">{`UIF-3066 - Typeahead Esc to clear (#12161)`}</li>
      <li parentName="ul">{`Polymorphic roles for Avatar and new ToolHeader SettingsActions (#12067)`}</li>
      <li parentName="ul">{`UIF-2613 Thumbnail Roles for Figure and Checkbox (#12097)`}</li>
      <li parentName="ul">{`UIF-2911 Tabs Tab role button (#12104)`}</li>
      <li parentName="ul">{`UIF-2651 Enhance Screen Reader Support for DateSelect spinbuttons (#12052)`}</li>
      <li parentName="ul">{`Prop to set max height to the Banner expandable content (#12062)`}</li>
      <li parentName="ul">{`Modal and Tearsheet close button aria i18n (#12216)`}</li>
      <li parentName="ul">{`core-react peerDep include React 18 (#12225)`}</li>
    </ul>
    <h2 {...{
      "id": "1160-2022-11-28",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1160-2022-11-28",
        "aria-label": "1160 2022 11 28 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@11.5.0...@procore/core-react@11.6.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`11.6.0`}</a>{` (2022-11-28)`}</h2>
    <h3 {...{
      "id": "bug-fixes-7",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-7",
        "aria-label": "bug fixes 7 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`UIF-2575 DateSelect Esc should close popup (#11811)`}</li>
      <li parentName="ul">{`MenuImperative clear button, Form Select crash (#11898)`}</li>
      <li parentName="ul">{`Tab anchor styles and dropdown keyboard (#11936)`}</li>
    </ul>
    <h3 {...{
      "id": "features-7",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-7",
        "aria-label": "features 7 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`UIF-2644 Screen Reader Support for Inline Errors (#11769)`}</li>
      <li parentName="ul">{`UIF-2650 Screen Reader Support for Calendar Month Navigation (#11814)`}</li>
      <li parentName="ul">{`UIF-2795 Screen Reader Support Form Fields Invalid (#11810)`}</li>
      <li parentName="ul">{`UIF-2809 Keyboard Navigation and Screen Reader Support for Breadcrumbs (#11901)`}</li>
      <li parentName="ul">{`add aria-live="polite" for selected items FileSelect (#11913)`}</li>
      <li parentName="ul">{`DateSelect to Calendar data-qa "core-date-select-calendar" (#11914)`}</li>
      <li parentName="ul">{`Icon only button aria labels (#11809)`}</li>
      <li parentName="ul">{`Pagination Select screen reader (#11819)`}</li>
      <li parentName="ul">{`Add link plugin to the editor toolbar for TextEditor (#11963)`}</li>
      <li parentName="ul">{`UIF-2810 Empty State semantics (#11938)`}</li>
      <li parentName="ul">{`UIF-2722 FileSelect upload zone announced content for screen readers (#11937)`}</li>
      <li parentName="ul">{`UIF-2594 Screen Reader Support for SelectableTile (Checkbox) (#11896)`}</li>
      <li parentName="ul">{`Implement GTK in NumberUtils getSeparators function (#11964)`}</li>
      <li parentName="ul">{`Deterministic start of Spinner (#11943)`}</li>
    </ul>
    <h2 {...{
      "id": "1150-2022-10-03",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1150-2022-10-03",
        "aria-label": "1150 2022 10 03 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@11.4.0...@procore/core-react@11.5.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`11.5.0`}</a>{` (2022-10-03)`}</h2>
    <h3 {...{
      "id": "bug-fixes-8",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-8",
        "aria-label": "bug fixes 8 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Modal scrolling overlays, fix z-index updating and isolate scroll detection (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/11721",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#11721`}</a>{`)`}</li>
      <li parentName="ul">{`NumberInput applied aria-hidden to step buttons (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/11675",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#11675`}</a>{`)`}</li>
      <li parentName="ul">{`Tearsheet scrim close click zone (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/11761",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#11761`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-8",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-8",
        "aria-label": "features 8 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`UIF-2447 - MenuImperative managing screen reader focus (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/11522",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#11522`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/11559",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#11559`}</a>
        <ul parentName="li">
          <li parentName="ul">{`adds `}<inlineCode parentName="li">{`aria-activedescendant`}</inlineCode>{` focus pattern to MenuImperative, integrated Dropdown, Select, PillSelect, MultiSelect, GroupSelect, TieredSelect, TieredDropdown`}</li>
          <li parentName="ul">{`adds a11y attributes for OverlayTrigger in Dropdown`}</li>
          <li parentName="ul">{`adds FocusScope `}<inlineCode parentName="li">{`containFocus`}</inlineCode>{` and `}<inlineCode parentName="li">{`autoFocus`}</inlineCode>{` from react-aria to `}<inlineCode parentName="li">{`OverlayTrigger`}</inlineCode></li>
        </ul>
      </li>
      <li parentName="ul">{`UIF-2593 - Screen Reader Support for Indeterminate Checkboxes (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/11719",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#11719`}</a>{`)`}</li>
      <li parentName="ul">{`UIF-2606 - Screen Reader Support for Dismissing Banners (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/11724",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#11724`}</a>{`)`}</li>
      <li parentName="ul">{`UIF-2253 - Screen Reader Support for Form Fields Label on Input (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/11723",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#11723`}</a>{`)`}</li>
      <li parentName="ul">{`UIF-2645 - Screen Reader Support for Form Error Banner (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/11760",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#11760`}</a>{`)`}</li>
      <li parentName="ul">{`UIF-2611 - Default Aria Label Dropdown and DropdownFlyout (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/11726",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#11726`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "refactors",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#refactors",
        "aria-label": "refactors permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Refactors`}</h3>
    <ul>
      <li parentName="ul">{`UIF-2361 - Segmented Controller as radio buttons (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/11708",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#11708`}</a>{`)`}</li>
      <li parentName="ul">{`refactor Switch component focusable for a11y (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/11767",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#11767`}</a>{`)`}</li>
    </ul>
    <h1 {...{
      "id": "1140-2022-09-15",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#1140-2022-09-15",
        "aria-label": "1140 2022 09 15 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h1" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@11.3.0...@procore/core-react@11.4.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`11.4.0`}</a>{` (2022-09-15)`}</h1>
    <h3 {...{
      "id": "bug-fixes-9",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-9",
        "aria-label": "bug fixes 9 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`reverts globalization-toolkit package requirement`}</li>
    </ul>
    <h3 {...{
      "id": "features-9",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-9",
        "aria-label": "features 9 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Add footer prop to allow custom footers in TieredSelect (#11590)`}</li>
    </ul>
    <h2 {...{
      "id": "1130-2022-09-07",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1130-2022-09-07",
        "aria-label": "1130 2022 09 07 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@11.2.0...@procore/core-react@11.3.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`11.3.0`}</a>{` (2022-09-07)`}</h2>
    <h3 {...{
      "id": "bug-fixes-10",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-10",
        "aria-label": "bug fixes 10 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`CMF-1964 Fixes error on clearing search on TieredDropdown (#11521)`}</li>
      <li parentName="ul">{`UIF-2501 - Button: unexpected string render result (#11502)`}</li>
      <li parentName="ul">{`Stop NumberInput setting state again when locales are the same (#11475)`}</li>
    </ul>
    <h3 {...{
      "id": "features-10",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-10",
        "aria-label": "features 10 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Expose user defined timezone on the useDateTime hook (#11548)`}</li>
      <li parentName="ul">{`Expose hour12 on the useDateTime hook (#11618)`}</li>
      <li parentName="ul">{`Add 'gap' property to Box and Flex component (#11550)`}</li>
      <li parentName="ul">{`UIF-942 Spinner centered prop (#11501)`}</li>
      <li parentName="ul">{`UIF-2449 added role for items based on MenuImperative role prop (#11441)`}</li>
      <li parentName="ul">{`Implement globalization-toolkit for NumberInput (#11558)`}</li>
      <li parentName="ul">{`Implement globalization-toolkit for CurrencyInput (#11595)`}</li>
    </ul>
    <h3 {...{
      "id": "internal-4",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#internal-4",
        "aria-label": "internal 4 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Internal`}</h3>
    <ul>
      <li parentName="ul">{`chore: ResizeObserver Polyfill on globalThis (#11622)`}</li>
      <li parentName="ul">{`refactor: OverlayTrigger rebase overlays on `}<inlineCode parentName="li">{`@floating-ui`}</inlineCode>{` (#11206)`}</li>
      <li parentName="ul">{`UIF-2412 Start OverlayTrigger ARIA role (#11476)`}</li>
      <li parentName="ul">{`NextMenu`}
        <ul parentName="li">
          <li parentName="ul">{`UIF-2309 NextMenu Styles (#11500)`}</li>
          <li parentName="ul">{`UIF-2310 Next menu infinity scrolling (#11477)`}</li>
          <li parentName="ul">{`Introducing Groups for NextMenu (#11428)`}</li>
          <li parentName="ul">{`NextMenu Header/Footer (#11589)`}</li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "1120-2022-08-03",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1120-2022-08-03",
        "aria-label": "1120 2022 08 03 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@11.1.0...@procore/core-react@11.2.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`11.2.0`}</a>{` (2022-08-03)`}</h2>
    <ul>
      <li parentName="ul">{`fix: make entire dropdown flyout item valid click target (#11358)`}</li>
      <li parentName="ul">{`fix: ToolHeader Icon props and onClick (#11435)`}</li>
      <li parentName="ul">{`feat: export type TableCellVariantProp (#11213)`}</li>
      <li parentName="ul">{`chore: remove unused react-styled-flexboxgrid dep, droped usage in v11 (#11399)`}</li>
    </ul>
    <h2 {...{
      "id": "1110-2022-07-15",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1110-2022-07-15",
        "aria-label": "1110 2022 07 15 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@11.0.2...@procore/core-react@11.1.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`11.1.0`}</a>{` (2022-07-15)`}</h2>
    <ul>
      <li parentName="ul">{`fix: Grid#gutterY to display when columns are not stacked (#11020)`}</li>
      <li parentName="ul">{`feat: Core React assure Bold (aka Semibold) font rules (#10955)`}</li>
      <li parentName="ul">{`feat: Exported getThumbnailVariantForFilename and ThumbnailDocumentIconVariant (#11124)`}</li>
      <li parentName="ul">{`feat: Multiselect translations (#11066)`}</li>
      <li parentName="ul">{`feat: add FileSelect afterHide, resetSources (#11172)`}</li>
      <li parentName="ul">{`feat: Improve a11y for ToggleButton with aria-pressed (#11126)`}</li>
      <li parentName="ul">{`feat: introduce Tearsheet#stretch API (#11215)`}</li>
    </ul>
    <h2 {...{
      "id": "1102-2022-06-08",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1102-2022-06-08",
        "aria-label": "1102 2022 06 08 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@11.0.1...@procore/core-react@11.0.2",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`11.0.2`}</a>{` (2022-06-08)`}</h2>
    <ul>
      <li parentName="ul">{`fix: default Aside visibility to be based on Page context (#11052)`}</li>
      <li parentName="ul">{`fix: Page Footer z-index (#10988)`}</li>
    </ul>
    <h2 {...{
      "id": "1101-2022-06-06",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1101-2022-06-06",
        "aria-label": "1101 2022 06 06 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@11.0.0...@procore/core-react@11.0.1",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`11.0.1`}</a>{` (2022-06-06)`}</h2>
    <ul>
      <li parentName="ul">{`fix: Menu passes onSearch to context (#10901)`}</li>
      <li parentName="ul">{`fix: wrapping of Tabs in the TabsList (#10868)`}</li>
      <li parentName="ul">{`fix: Section aria labelledby for region in non-accordion case (#10739)`}</li>
      <li parentName="ul">{`fix: Move Portal zIndex to Inline Style (#10869)`}</li>
      <li parentName="ul">{`fix: Add type exports MultiSelectOptionProps, GroupSelectOptionRendererParams (#10960)`}</li>
      <li parentName="ul">{`fix: Tree make isExpanded a transient prop (#10950)`}</li>
    </ul>
    <h2 {...{
      "id": "1100-2022-05-16",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1100-2022-05-16",
        "aria-label": "1100 2022 05 16 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@10.30.0...@procore/core-react@11.0.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`11.0.0`}</a>{` (2022-05-16)`}</h2>
    <h3 {...{
      "id": "breaking-changes",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#breaking-changes",
        "aria-label": "breaking changes permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`BREAKING CHANGES`}</h3>
    <p>{`See `}<a parentName="p" {...{
        "href": "https://core.procore.com/11.0.0/web/releases/migration-guides/core-react/v10-to-v11/",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`v11 migration guide`}</a>{`.`}</p>
    <ul>
      <li parentName="ul">{`flatten imports, remove esm folder`}</li>
      <li parentName="ul">{`remove Core CSS from deps`}</li>
      <li parentName="ul">{`remove Font component`}</li>
      <li parentName="ul">{`remove string icon support from all components`}</li>
      <li parentName="ul">{`remove Button_Prev component`}</li>
      <li parentName="ul">{`remove LegacyDetailPage`}</li>
      <li parentName="ul">{`remove DetailPage component`}</li>
      <li parentName="ul">{`rename NextDetailPage to DetailPage`}</li>
      <li parentName="ul">{`remove Grid component`}</li>
      <li parentName="ul">{`rename NextGrid to Grid`}</li>
      <li parentName="ul">{`remove IconLayout component`}</li>
      <li parentName="ul">{`remove Token.Icon`}</li>
      <li parentName="ul">{`remove fieldLabel from Pagination`}</li>
      <li parentName="ul">{`remove old button variants`}</li>
      <li parentName="ul">{`remove Pagination subcomponents`}</li>
      <li parentName="ul">{`remove TextEditorProvider. optional, reintroduced with new API in 11.10`}</li>
    </ul>
    <h2 {...{
      "id": "10300-2022-05-16",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10300-2022-05-16",
        "aria-label": "10300 2022 05 16 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@10.29.0...@procore/core-react@10.30.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.30.0`}</a>{` (2022-05-16)`}</h2>
    <h3 {...{
      "id": "features-11",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-11",
        "aria-label": "features 11 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Localized hint date format alphas for DateSelect (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10673",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10673`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "bug-fixes-11",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-11",
        "aria-label": "bug fixes 11 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`add border color change on hover for Search and Typeahead and unify styles (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10677",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10677`}</a>{`)`}</li>
      <li parentName="ul">{`Update useField setValue api to accept shouldMarkDiff (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10630",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10630`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10290-2022-05-09",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10290-2022-05-09",
        "aria-label": "10290 2022 05 09 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@10.28.0...@procore/core-react@10.29.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.29.0`}</a>{` (2022-05-09)`}</h2>
    <h3 {...{
      "id": "features-12",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-12",
        "aria-label": "features 12 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`MultiSelect Footer (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10633",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10633`}</a>{`)`}</li>
      <li parentName="ul">{`Added support for zh-SG locale in DateSelect, DateInput (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10634",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10634`}</a>{`)`}</li>
      <li parentName="ul">{`Modal and Tearsheet close button aria label (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10595",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10595`}</a>{`)`}</li>
      <li parentName="ul">{`Tabs, Checkbox, RadioButtons, Slider color updates (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10602",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10602`}</a>{`)`}</li>
      <li parentName="ul">{`Expose FileList in docs, released in 10.23.0`}</li>
    </ul>
    <h3 {...{
      "id": "bug-fixes-12",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-12",
        "aria-label": "bug fixes 12 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Select spinner should be blue (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10679",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10679`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10280-2022-04-25",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10280-2022-04-25",
        "aria-label": "10280 2022 04 25 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@10.27.2...@procore/core-react@10.28.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.28.0`}</a>{` (2022-04-25)`}</h2>
    <h3 {...{
      "id": "features-13",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-13",
        "aria-label": "features 13 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Update Color Palette (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10473",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10473`}</a>{`)`}</li>
      <li parentName="ul">{`Dropdown button appears focused when its open and without search (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10460",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10460`}</a>{`)`}</li>
      <li parentName="ul">{`Update icons, adds NotepadPencil, NotepadPeople, RibbonOff, Timeline (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10462",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10462`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "bug-fixes-13",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-13",
        "aria-label": "bug fixes 13 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Dropdown Flyout Menu Adjustment (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10458",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10458`}</a>{`)`}</li>
      <li parentName="ul">{`Page layout fixes when small content (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10474",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10474`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10272-2022-04-08",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10272-2022-04-08",
        "aria-label": "10272 2022 04 08 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@10.27.1...@procore/core-react@10.27.2",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.27.2`}</a>{` (2022-04-08)`}</h2>
    <h3 {...{
      "id": "bug-fixes-14",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-14",
        "aria-label": "bug fixes 14 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`DropdownFlyout bottom placements (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10085",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10085`}</a>{`)`}</li>
      <li parentName="ul">{`fixing Pagination logic to handle empty state (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10400",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10400`}</a>{`)`}</li>
      <li parentName="ul">{`Translations update (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10449",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10449`}</a>{`)`}</li>
      <li parentName="ul">{`Sidebar deprecation JSDoc (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10419",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10419`}</a>{`)`}</li>
      <li parentName="ul">{`default lang if none provided for hook used by NumberInput (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10448",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10448`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10271-2022-03-30",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10271-2022-03-30",
        "aria-label": "10271 2022 03 30 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/@procore/core-react@10.27.0...@procore/core-react@10.27.1",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.27.1`}</a>{` (2022-03-30)`}</h2>
    <h3 {...{
      "id": "bug-fixes-15",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-15",
        "aria-label": "bug fixes 15 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Core Icons webpack5 drop file-loader in favor of asset modules (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10334",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10334`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10270-2022-03-28",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10270-2022-03-28",
        "aria-label": "10270 2022 03 28 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.25.0...@procore/core-react@10.27.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.27.0`}</a>{` (2022-03-28)`}</h2>
    <h3 {...{
      "id": "bug-fixes-16",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-16",
        "aria-label": "bug fixes 16 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`NumberInput works with decimals again. Keeps nature that string values are in the locale format (this was changed in 10.23.0 but reverted here). (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10248",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10248`}</a>{`)`}</li>
      <li parentName="ul">{`Make Calendar use formatterLocale (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10012",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10012`}</a>{`)`}</li>
      <li parentName="ul">{`Fix MultiSelect onhide bug (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9990",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9990`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-14",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-14",
        "aria-label": "features 14 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Add missing Dropdown.Group (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10164",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10164`}</a>{`)`}</li>
      <li parentName="ul">{`Link underline default and focus state (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10086",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10086`}</a>{`)`}</li>
      <li parentName="ul">{`Add Token.Remove component, deprecate Token.Icon (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10217",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10217`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10303",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10303`}</a>{`)`}</li>
      <li parentName="ul">{`NumberInput deprecate locale prop, use I18nProvider (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10259",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10259`}</a>{`)`}</li>
      <li parentName="ul">{`Introduce sliding animation to Page.Aside (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9982",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9982`}</a>{`)`}</li>
    </ul>
    <h1 {...{
      "id": "10260",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#10260",
        "aria-label": "10260 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`10.26.0`}</h1>
    <ul>
      <li parentName="ul">{`Bad publish. DO NOT USE`}</li>
    </ul>
    <h2 {...{
      "id": "10250-2022-03-01",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10250-2022-03-01",
        "aria-label": "10250 2022 03 01 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.24.0...v10.25.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.25.0`}</a>{` (2022-03-01)`}</h2>
    <h3 {...{
      "id": "features-15",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-15",
        "aria-label": "features 15 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`New Tearsheet component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10077",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10077`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3c998bb114243b82c77c18a603569ca129c03c81",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3c998bb`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10240-2022-02-25",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10240-2022-02-25",
        "aria-label": "10240 2022 02 25 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.23.0...v10.24.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.24.0`}</a>{` (2022-02-25)`}</h2>
    <h3 {...{
      "id": "features-16",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-16",
        "aria-label": "features 16 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[UIF-1561]`}{` TextEditorOutput Component and remove margins for p in TextEditor (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9930",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9930`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/aebe93923d78b5a03906d3199efb98831a2ff42a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`aebe939`}</a>{`)`}</li>
      <li parentName="ul">{`Add more 3d model and drawing extensions (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/10013",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#10013`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/445edb82cd2fcf6bf0d92a8f6dfa90c27af56deb",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`445edb8`}</a>{`)`}</li>
      <li parentName="ul">{`Export spacing (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9991",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9991`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3c0c505c1969361bbb04e8935055254fb21fa714",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3c0c505`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10230-2022-02-15",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10230-2022-02-15",
        "aria-label": "10230 2022 02 15 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.22.1...v10.23.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.23.0`}</a>{` (2022-02-15)`}</h2>
    <h3 {...{
      "id": "bug-fixes-17",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-17",
        "aria-label": "bug fixes 17 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`fix page layout in tearsheet IE11 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9956",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9956`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/943f1b38a8add0d2e07d433396d39fcf5b9f5566",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`943f1b3`}</a>{`)`}</li>
      <li parentName="ul">{`fix panel footer actions alignment (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9973",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9973`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ae4667ada542acb3b733cdd320608479ac964cae",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ae4667a`}</a>{`)`}</li>
      <li parentName="ul">{`NumberInput unformatted string values properly format to locale (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9878",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9878`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/8f6f4a5288e71346470e9d3fc98785e36fcc2773",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`8f6f4a5`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-17",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-17",
        "aria-label": "features 17 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[UIF-427]`}{` JSS for FileList Component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9934",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9934`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/dec1307a590e22dccd9e40aeba4e338d670fde6f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`dec1307`}</a>{`)`}</li>
      <li parentName="ul">{`add initial Tearsheet implementation (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9845",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9845`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a51a0be2badb5c8a7b8928cc4d1428639be8b397",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a51a0be`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` animate tree chevron (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f39b2f8ed5886b32a40a6877aebdaef0e519da9e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f39b2f8`}</a>{`)`}</li>
      <li parentName="ul">{`Data attr pattern to acknowledge a11y failures. Ack color contrast on orange Buttons (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9917",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9917`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/84b98cd3b39aa1d55a4ac74efc86452e35cc5dd6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`84b98cd`}</a>{`)`}</li>
      <li parentName="ul">{`validate locale and fallback to en (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9913",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9913`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2ca7e3c3bb55ee91378f992dcb0d48744506df0c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2ca7e3c`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10221-2022-02-03",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10221-2022-02-03",
        "aria-label": "10221 2022 02 03 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.22.0...v10.22.1",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.22.1`}</a>{` (2022-02-03)`}</h2>
    <h3 {...{
      "id": "reverts",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#reverts",
        "aria-label": "reverts permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Reverts`}</h3>
    <ul>
      <li parentName="ul">{`Form type change of omitting value (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9935",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9935`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/63b2f9e6fbc425fbc69a6b95268774c3571b590d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`63b2f9e`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10220-2022-02-01",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10220-2022-02-01",
        "aria-label": "10220 2022 02 01 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.21.0...v10.22.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.22.0`}</a>{` (2022-02-01)`}</h2>
    <h3 {...{
      "id": "bug-fixes-18",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-18",
        "aria-label": "bug fixes 18 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Form Fields edit props trickle and omit value type (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9850",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9850`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3bf9a368195609f95900b2a732137b67958cd3a2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3bf9a36`}</a>{`)`}</li>
      <li parentName="ul">{`Modal small content in a wide Modal (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9912",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9912`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/df27882d23efc52abcd14c02d100d2ca0e1cf7b6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`df27882`}</a>{`)`}</li>
      <li parentName="ul">{`NumberInput controlled conditional state updates (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9904",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9904`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/155177abc8056a2e4e3376086137e58435efda40",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`155177a`}</a>{`)`}</li>
      <li parentName="ul">{`numberInput watch value to allow controlled input accept decimal (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9853",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9853`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2fd7c6655148f06c24e435b6fed15d33c30bfc18",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2fd7c66`}</a>{`)`}</li>
      <li parentName="ul">{`pill select options width (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9880",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9880`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a6a2d79b450970ff626724a6477ed9b0533bfaff",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a6a2d79`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-18",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-18",
        "aria-label": "features 18 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[UIF-1631]`}{` - AvatarStack: Add getInitials and getImageUrl (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9808",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9808`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/1fe596f134c6cdb3220d9fa5b222186dbc89fae6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1fe596f`}</a>{`)`}</li>
      <li parentName="ul">{`SVG Icons with displayName. fix: add aria-label to Icon only Buttons (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9911",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9911`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e247b8e4e20bb4062e57d7becada5b8670637018",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e247b8e`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10210-2022-01-14",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10210-2022-01-14",
        "aria-label": "10210 2022 01 14 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.20.0...v10.21.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.21.0`}</a>{` (2022-01-14)`}</h2>
    <h3 {...{
      "id": "bug-fixes-19",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-19",
        "aria-label": "bug fixes 19 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[UIF-1673]`}{` Fix type exports (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9849",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9849`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/96d7ca35881dbe13b65f98db0852f3cafeec7dfe",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`96d7ca3`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` tree expansion by chevron was not working when row was also selectable (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3e2733d69c20c5c70ded809542fe2d041ffb23d1",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3e2733d`}</a>{`)`}</li>
      <li parentName="ul">{`DateInput onChange and value fixes (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9779",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9779`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/83e88093e6c2fb77383e1b7463a18151551d1648",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`83e8809`}</a>{`)`}</li>
      <li parentName="ul">{`DateInput/DateSelect aria label for time zones (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9827",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9827`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5da935e4d5e946c176ab88d93f5aa89dbdb110ac",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5da935e`}</a>{`)`}</li>
      <li parentName="ul">{`fix Tabs resize issue (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9781",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9781`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5aa7fa1fdcef915f3d7b755628f9943f9ae31f1b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5aa7fa1`}</a>{`)`}</li>
      <li parentName="ul">{`fix TextEditor locale (TinyMCE) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9807",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9807`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ea41c19d9ccd465e09a8141e920bd88fc2ce4e94",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ea41c19`}</a>{`)`}</li>
      <li parentName="ul">{`fixes bug with DateInput onChange when value is undefined (initially) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9825",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9825`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d38faaecc0a38a0aeb08ad02d580dd7d7d5aae42",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d38faae`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-19",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-19",
        "aria-label": "features 19 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` add magenta and cyan to color palette and Pill component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3fcba5b117c8fac7cca1fbfb309811abc265dc60",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3fcba5b`}</a>{`)`}</li>
      <li parentName="ul">{`Toggle Button release (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9848",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9848`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f956c29dc608e7603060bff3e83125d144866413",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f956c29`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10200-2021-12-16",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10200-2021-12-16",
        "aria-label": "10200 2021 12 16 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.19.0...v10.20.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.20.0`}</a>{` (2021-12-16)`}</h2>
    <h3 {...{
      "id": "bug-fixes-20",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-20",
        "aria-label": "bug fixes 20 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[UIF-637]`}{` Tree child nodes indentation (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9760",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9760`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5d0370d122d0d928239ad7678a7447479b273c14",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5d0370d`}</a>{`)`}</li>
      <li parentName="ul">{`fix slider key warning (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9718",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9718`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f2b7ca03364f4288968d8fa4adf6842447fc71c2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f2b7ca0`}</a>{`)`}</li>
      <li parentName="ul">{`Section use latest Chevron svg icons (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9713",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9713`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/771f5fcb4985eed738f1cf7941a411cea6f74d1c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`771f5fc`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-20",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-20",
        "aria-label": "features 20 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[UIF-1067]`}{` Move content from prop docs to typedoc (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9679",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9679`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a4d987450df80bc2a3901dbfbf06572e2e1e8148",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a4d9874`}</a>{`)`}</li>
      <li parentName="ul">{`[UIF-1409]`}{` Add new Thumbnail icons, some Folders and Cube (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9680",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9680`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c3b70bb318d456fc1ed523a20a1291d1703a4667",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c3b70bb`}</a>{`)`}</li>
      <li parentName="ul">{`Icons update chevrons. New: StarOff, Fire, FileEye, EnvelopeOpen, Archive (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9721",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9721`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c3b56b037585aec7218bdacfe2b0adad362e8c35",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c3b56b0`}</a>{`)`}</li>
      <li parentName="ul">{`make aside block sticky (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9676",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9676`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a9e0c413901a52565c0142f2d67b61f9e6fd17eb",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a9e0c41`}</a>{`)`}</li>
      <li parentName="ul">{`reorder docs/storybook icons for panel component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9663",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9663`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/0b04402fd553f9cad7dafa4d6ebe7b964236d40b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`0b04402`}</a>{`)`}</li>
      <li parentName="ul">{`Smartling translations for zh-SG (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9717",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9717`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/4187ea5b20102548954bd6639f64c9dbc36fe227",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`4187ea5`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10190-2021-11-12",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10190-2021-11-12",
        "aria-label": "10190 2021 11 12 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.18.0...v10.19.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.19.0`}</a>{` (2021-11-12)`}</h2>
    <h3 {...{
      "id": "bug-fixes-21",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-21",
        "aria-label": "bug fixes 21 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Modal, Panel, DetailPage, Section Spacing and Headings (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9659",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9659`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/cd7976fcd819cbfc64e150af98fe7f3179411797",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`cd7976f`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-21",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-21",
        "aria-label": "features 21 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Box as ol, ul, li with browser reset (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9433",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9433`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ca11c213af35ba7eff9099579937bf246f7d4a1a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ca11c21`}</a>{`)`}</li>
      <li parentName="ul">{`Content layout component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9590",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9590`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3a43471c4837dc19a1c2bc6e0b7fd969269e19fe",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3a43471`}</a>{`)`}</li>
      <li parentName="ul">{`disabled menu items for tiered dropdown (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9608",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9608`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/424e615d1c2ff87a040183bb585f838f4b47ebef",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`424e615`}</a>{`)`}</li>
      <li parentName="ul">{`Release Title, Tile, Content, NextDetailPage (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9662",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9662`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a33ee9942cea831fc48d17640feffa9845f474e3",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a33ee99`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10180-2021-11-09",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10180-2021-11-09",
        "aria-label": "10180 2021 11 09 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.17.0...v10.18.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.18.0`}</a>{` (2021-11-09)`}</h2>
    <h3 {...{
      "id": "features-22",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-22",
        "aria-label": "features 22 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[FDN-1073]`}{` Storybook deploys for master + develop (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9587",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9587`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2c47de33db56916a7be66ea37c204365a54c6c26",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2c47de3`}</a>{`)`}</li>
      <li parentName="ul">{`[UIF-1069]`}{` Toggle Button component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9607",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9607`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/1098c0a85f5ff008107ea509081e9a488cb62091",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1098c0a`}</a>{`)`}</li>
      <li parentName="ul">{`[UIF-1323]`}{` Storybook Core Brand (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9636",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9636`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/23c60953283c78f9abab7d2614e2b2b6c5b63bbe",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`23c6095`}</a>{`)`}</li>
      <li parentName="ul">{`add index file for DetailPage component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9639",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9639`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2959392361a4e8125cc6abc5a77972259e8c90bc",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2959392`}</a>{`)`}</li>
      <li parentName="ul">{`add panel close button (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9606",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9606`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/55897356d2aad03dfc32b046c7da99fafb430043",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5589735`}</a>{`)`}</li>
      <li parentName="ul">{`alphabetical sorting for storybook stories (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9613",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9613`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/343742779ba89351533b6ce5450727802f964edc",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3437427`}</a>{`)`}</li>
      <li parentName="ul">{`expose Section on Panel and Modal (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9588",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9588`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e94564fcc555422e0dc320c37e1b8bcfd1dc8785",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e94564f`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10170-2021-10-27",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10170-2021-10-27",
        "aria-label": "10170 2021 10 27 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.16.0...v10.17.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.17.0`}</a>{` (2021-10-27)`}</h2>
    <h3 {...{
      "id": "bug-fixes-22",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-22",
        "aria-label": "bug fixes 22 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[FDN-1328]`}{` Fix docs build (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9592",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9592`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/39ae28f9e1d3012d3e33990f5273a482bf6cae11",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`39ae28f`}</a>{`)`}</li>
      <li parentName="ul">{`empty divs (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9559",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9559`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/43d134f65b11893735c7f92116283f3ad6a6e63a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`43d134f`}</a>{`)`}</li>
      <li parentName="ul">{`fix loading button IE11 position (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9550",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9550`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e4119fea882fe1d66ec98c2e26ce28e72434ef49",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e4119fe`}</a>{`)`}</li>
      <li parentName="ul">{`Fix Segmented Controller button styles with app css creep (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9555",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9555`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7c7dbb4166f168d40e310acfc83ca96553e560e6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7c7dbb4`}</a>{`)`}</li>
      <li parentName="ul">{`gatsby specific window check (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9609",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9609`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b7210ad513f581d048e377ab542f557aec8c128c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b7210ad`}</a>{`)`}</li>
      <li parentName="ul">{`Support NumberInput for special locales (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9593",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9593`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/bb1ccf28f5f68290ac8f583220f2f81f6a93962e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`bb1ccf2`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-23",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-23",
        "aria-label": "features 23 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[FDN-860]`}{` Modal - divider under header (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9531",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9531`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f6da899372163e436f7c8fb566d1c11b61e63821",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f6da899`}</a>{`)`}</li>
      <li parentName="ul">{`[FDN-931]`}{` Tile component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9517",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9517`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ad433675a7ff267effdc4cb6088c7fd4eb2db87a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ad43367`}</a>{`)`}</li>
      <li parentName="ul">{`[FDN-950]`}{` update file type icons in thumbnail (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9574",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9574`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/be99bc96ac44f8b9f602034327f185a48c81f657",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`be99bc9`}</a>{`)`}</li>
      <li parentName="ul">{`add drag and drop keyboard controls to MenuImperative (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9500",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9500`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/52ba710b400897e7f60b345d03d07bdb1ec47a4a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`52ba710`}</a>{`)`}</li>
      <li parentName="ul">{`Modal widths (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9498",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9498`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7daec240ae7ec959b582a5ac1189aca54576d82e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7daec24`}</a>{`)`}</li>
      <li parentName="ul">{`New Component - Tiered Dropdown `}{`[CMF-980]`}{` (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9529",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9529`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/16c5a2aaf15d2a16fd27eb739bebd0f9231ff18d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`16c5a2a`}</a>{`)`}</li>
      <li parentName="ul">{`New Component - Title (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9499",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9499`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d2c458014fef7db8c34ad9d5373741c15f74a149",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d2c4580`}</a>{`)`}</li>
      <li parentName="ul">{`Release Page, NextDetailpage, and NextGrid components (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9456",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9456`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b546f4c1d4f58405dd97493656aa8633191e274b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b546f4c`}</a>{`)`}</li>
      <li parentName="ul">{`support Calendar for locales where the start day of the week is not Sunday (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9557",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9557`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a9040aabe701bf10afe93a2ca77c8828d2584222",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a9040aa`}</a>{`)`}</li>
      <li parentName="ul">{`Switch component renders children and can be consecutively spaced (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9551",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9551`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3819f7066971bf07537e8dd652b4386dccb1aa6f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3819f70`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` Add async beforeLocalFileUpload callback to FileSelect to prevent upload (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9440",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9440`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3fbf2541b9c4382dfd9b1f0c88c87f2d8c055dfb",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3fbf254`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10160-2021-10-01",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10160-2021-10-01",
        "aria-label": "10160 2021 10 01 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.15.0...v10.16.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.16.0`}</a>{` (2021-10-01)`}</h2>
    <h3 {...{
      "id": "bug-fixes-23",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-23",
        "aria-label": "bug fixes 23 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[FDN-892]`}{` Dropdown Overflows IE11 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9459",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9459`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3026e18e663cc4807fefb5856810998b8f9eb9ae",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3026e18`}</a>{`)`}</li>
      <li parentName="ul">{`fix to MenuImperative keyboard nav Up arrow across groups (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9469",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9469`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/99d0d6573e6c10c64525fd4c38f571c609b7e65d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`99d0d65`}</a>{`)`}</li>
      <li parentName="ul">{`remove NumberInput code duplication (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9494",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9494`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/25bf8cf457bc785311a77e022e2473619c86108c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`25bf8cf`}</a>{`)`}</li>
      <li parentName="ul">{`Vulnerability update axios from 0.21.1 to 0.21.3 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9475",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9475`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/07059396dad6fd58a33b670f13952f96154099d3",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`0705939`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-24",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-24",
        "aria-label": "features 24 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`add suffix prop to NumberInput (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9435",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9435`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/aedba7b188d207bbc55171308d4cc57344f23a14",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`aedba7b`}</a>{`)`}</li>
      <li parentName="ul">{`Locales de-DE, fr-FR, es-ES (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9438",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9438`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6f92813a6d411f5d7f301be5c6c059673e8d9334",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6f92813`}</a>{`)`}</li>
      <li parentName="ul">{`Pagination component allow prop spread (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9492",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9492`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f75a5c9645350c3eb51828f3ae247e6a024224f1",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f75a5c9`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10150-2021-08-30",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10150-2021-08-30",
        "aria-label": "10150 2021 08 30 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.14.0...v10.15.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.15.0`}</a>{` (2021-08-30)`}</h2>
    <h3 {...{
      "id": "bug-fixes-24",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-24",
        "aria-label": "bug fixes 24 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Dropzone button style is secondary button (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9430",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9430`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/50bb3a79cb5ed6d253bde0acd6b125306306fd98",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`50bb3a7`}</a>{`)`}</li>
      <li parentName="ul">{`IE11 DateSelect mouse date selection from Calendar (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9434",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9434`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a1de344e7ad5a8dccb529847b3f431c7316438d5",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a1de344`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-25",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-25",
        "aria-label": "features 25 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Update icons, align with mobile bolder style (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9445",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9445`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7bf8cb434025e93161606dee83df742f1b22b7c3",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7bf8cb4`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10140-2021-08-23",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10140-2021-08-23",
        "aria-label": "10140 2021 08 23 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.13.0...v10.14.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.14.0`}</a>{` (2021-08-23)`}</h2>
    <h3 {...{
      "id": "bug-fixes-25",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-25",
        "aria-label": "bug fixes 25 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Define color on Checkbox and RadioButton (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9414",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9414`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2c459ee95bf970d040aa69398c1e3326b9135b63",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2c459ee`}</a>{`)`}</li>
      <li parentName="ul">{`fix custom token not being displayed (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9372",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9372`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/effe943f8494f0324cfc0b60dd4cb3e3c9951675",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`effe943`}</a>{`)`}</li>
      <li parentName="ul">{`MultiSelect always show dropdown when clicking on clear all button (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9399",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9399`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/49058c7a046bfb678c7f999c3fa23786934c1127",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`49058c7`}</a>{`)`}</li>
      <li parentName="ul">{`Support MenuImperative dragging inside a Modal (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9394",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9394`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2643e19d8e7533f0b24d14962fac312074a29f13",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2643e19`}</a>{`)`}</li>
      <li parentName="ul">{`types/styles when using MenuImperative.CheckboxItem with drag and drop enabled (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9393",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9393`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/27421bd5886c1c370e65e6d8bee7416b81bbcff7",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`27421bd`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-26",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-26",
        "aria-label": "features 26 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Add Imperative menu drag and drop (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9353",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9353`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b3b6c7c7a078cd55a69dc56a6445064331f7a874",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b3b6c7c`}</a>{`)`}</li>
      <li parentName="ul">{`Add MenuImperative.CheckboxItem (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9351",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9351`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a8687d59b736ed1ef2d8c2052ac69329eb96f003",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a8687d5`}</a>{`)`}</li>
      <li parentName="ul">{`introduce NextDetailPage (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9397",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9397`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/cc8476ae557c70b330ed0ae20f00149454099112",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`cc8476a`}</a>{`)`}</li>
      <li parentName="ul">{`updating to latest tinymce version (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9375",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9375`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/56f834d62cd66e52fdcd8cce6262d9abf544a35b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`56f834d`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10130-2021-08-04",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10130-2021-08-04",
        "aria-label": "10130 2021 08 04 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.12.0...v10.13.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.13.0`}</a>{` (2021-08-04)`}</h2>
    <h3 {...{
      "id": "features-27",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-27",
        "aria-label": "features 27 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Add Modal.FooterSummary component to Modal (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9327",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9327`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/61ddd1bd364f90a686438e85334fb06dae9ac764",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`61ddd1b`}</a>{`)`}</li>
      <li parentName="ul">{`introduce PageLayout and NextGrid components (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9005",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9005`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/88d0c64eef69c7906c0788b2210a4c54a21dd257",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`88d0c64`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10120-2021-07-20",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10120-2021-07-20",
        "aria-label": "10120 2021 07 20 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.11.0...v10.12.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.12.0`}</a>{` (2021-07-20)`}</h2>
    <h3 {...{
      "id": "bug-fixes-26",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-26",
        "aria-label": "bug fixes 26 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[FDN-790]`}{` Popover OverlayTrigger not correct position on first load and Percy Failures (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8997",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8997`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/0d48a4034588c0308eaf55a47eb46af48e3b35d4",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`0d48a40`}</a>{`)`}</li>
      <li parentName="ul">{`Form PillSelect Optional Clear Button, PillSelect Optional Options (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9283",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9283`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e2d2cf0229f140ffe68c132016dff9878ca0d17e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e2d2cf0`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-28",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-28",
        "aria-label": "features 28 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[FDN-712]`}{` introduce LinkButton component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9038",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9038`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/23b4db2b004a73779bca5b024616712467b29946",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`23b4db2`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10110-2021-07-01",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10110-2021-07-01",
        "aria-label": "10110 2021 07 01 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.10.0...v10.11.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.11.0`}</a>{` (2021-07-01)`}</h2>
    <h3 {...{
      "id": "bug-fixes-27",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-27",
        "aria-label": "bug fixes 27 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`fix useDeprecation behaviour with falsy values and quiet console (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9031",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9031`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/192fbb6ca9ca2e5a930536b20d06cd8adeb97bae",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`192fbb6`}</a>{`)`}</li>
      <li parentName="ul">{`Icon Highlighter Name (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9146",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9146`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/08c8eddc17528be80da11b749352848ac61ec437",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`08c8edd`}</a>{`)`}</li>
      <li parentName="ul">{`Remove Card Shadow Strength Half Steps (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9149",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9149`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/8e616318e2c3bf7225f15ce7cc1888a0005f1fe6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`8e61631`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-29",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-29",
        "aria-label": "features 29 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[FDN-752]`}{` - Form field empty state implementation (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9069",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9069`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/dc777f6938a404d31c11730b81dc2bbfc550141a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`dc777f6`}</a>{`)`}</li>
      <li parentName="ul">{`introduce onUploadStateChange (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9128",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9128`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c8a012ff25b52d0313597f36a2e92d5724b1608f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c8a012f`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "10100-2021-06-11",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#10100-2021-06-11",
        "aria-label": "10100 2021 06 11 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.9.0...v10.10.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.10.0`}</a>{` (2021-06-11)`}</h2>
    <h3 {...{
      "id": "bug-fixes-28",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-28",
        "aria-label": "bug fixes 28 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` remove margins from slider (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9021",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9021`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/cf66600b70b5ecf8f3274fceb1efbd31325f0f71",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`cf66600`}</a>{`)`}</li>
      <li parentName="ul">{`core-docs build (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8990",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8990`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/74c9c9989100504fcaa1c55e3b7b9f9399f204d6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`74c9c99`}</a>{`)`}</li>
      <li parentName="ul">{`mock new Date for Calendar current day tests, fix Displaydate (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8910",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8910`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/9c309902eaedab6ad02df0d732ff0245a3c5cdbf",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`9c30990`}</a>{`)`}</li>
      <li parentName="ul">{`Range -> Slider, UX fixes for Slider (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8946",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8946`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e6e498d3700f0277236be6752b961750f008adc3",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e6e498d`}</a>{`)`}</li>
      <li parentName="ul">{`set medium icon size to 16px for avatars (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9022",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9022`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ac61f242addc3e58af503a2f22ee42982dde5f9a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ac61f24`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` debug logging for flatMap issue in FileSelect (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8979",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8979`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/78e0ebe8b1dcf80a82b802b37c44a02c22fd374c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`78e0ebe`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-30",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-30",
        "aria-label": "features 30 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[FDN-393]`}{` Apply New Shadow to Card and components that use Card (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8834",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8834`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/966463a114e8b5ffa15b5c4722c8a1bb748bb529",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`966463a`}</a>{`)`}</li>
      <li parentName="ul">{`[FDN-393]`}{` change Banner shadow position to bottom (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9015",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9015`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/4ad398ed474856ef707f24bfb251c644b4dc24d1",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`4ad398e`}</a>{`)`}</li>
      <li parentName="ul">{`[FDN-718]`}{` Update Shadow Palette (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9058",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9058`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d17355ed1f2cb6e4fd53c73c8ab8fa066f73580b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d17355e`}</a>{`)`}</li>
      <li parentName="ul">{`apply new shadow to Banner (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8931",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8931`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/72420f47df77a115cf98f0ec4879c250c8d06fbe",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`72420f4`}</a>{`)`}</li>
      <li parentName="ul">{`apply new shadow to menu (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8934",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8934`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/1d9742aa0bf4a533ed067504c404fab2875143f0",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1d9742a`}</a>{`)`}</li>
      <li parentName="ul">{`debug console error for file select sources bug (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8972",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8972`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d9210d52490d454e906b1cb59a826100f3b60dd6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d9210d5`}</a>{`)`}</li>
      <li parentName="ul">{`FDN-393 Apply new shadow to Popover (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8932",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8932`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/fa0e816db776f42e5ec6750701ea85c6e8917611",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`fa0e816`}</a>{`)`}</li>
      <li parentName="ul">{`FDN-393 Apply New Shadows to Components (Table) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8923",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8923`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/91f9ae29e1b44caf88c1228166d72ed0465d3c46",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`91f9ae2`}</a>{`)`}</li>
      <li parentName="ul">{`update icons (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9098",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9098`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5d5acc47b842360b5bf897562eda0b858f316a8a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5d5acc4`}</a>{`)`}</li>
      <li parentName="ul">{`Update icons, many markup icons (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9085",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9085`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/4d67e5563acade75e764b85277b43dce6b257e74",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`4d67e55`}</a>{`)`}</li>
      <li parentName="ul">{`update translations for RelatedItems (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9049",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9049`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a2b2ee43e88fdcbd19521ca4ceb32ea7ed483725",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a2b2ee4`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "reverts-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#reverts-1",
        "aria-label": "reverts 1 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Reverts`}</h3>
    <ul>
      <li parentName="ul">{`revert "chore(deps-dev): bump typescript from 4.2.4 to 4.3.2 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8978",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8978`}</a>{`)" (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/9000",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#9000`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ca69d658c21960bd8f0dea3067b92735e42d5c1d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ca69d65`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "1090-2021-05-25",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1090-2021-05-25",
        "aria-label": "1090 2021 05 25 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.8.0...v10.9.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.9.0`}</a>{` (2021-05-25)`}</h2>
    <h3 {...{
      "id": "bug-fixes-29",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-29",
        "aria-label": "bug fixes 29 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`fix table border radius typo (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8912",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8912`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/424e4bafb5c303b5146c455d0deb789748d10b07",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`424e4ba`}</a>{`)`}</li>
      <li parentName="ul">{`fix textarea resize (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8943",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8943`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5cd43c834f08da69b4bb4a2ba376654f2831b979",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5cd43c8`}</a>{`)`}</li>
      <li parentName="ul">{`Form.RichText re-positions cursor to beginning of field on change event - V2 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8889",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8889`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ecf1e7009f87eb4effa1e972413163ac5b805efc",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ecf1e70`}</a>{`)`}</li>
      <li parentName="ul">{`Form.RichText re-positions cursor to beginning of field on change event. (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8872",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8872`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/04ad1611b0e8111471e0b7862ea9dce4b326483e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`04ad161`}</a>{`)`}</li>
      <li parentName="ul">{`range slider ie11 use height over border trick (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/8b31b1c0d26a655e407854fa5f5cc67dbb7bf5ba",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`8b31b1c`}</a>{`)`}</li>
      <li parentName="ul">{`range slider remove tick marks (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e8e62fa75e858cce939ca019522afc58893dd97e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e8e62fa`}</a>{`)`}</li>
      <li parentName="ul">{`range slider styles ie (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7347e7c35a2c334ab3aede7cc452ced5585255ad",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7347e7c`}</a>{`)`}</li>
      <li parentName="ul">{`RichTextEditor has to perform a check on Form enableReinitialize before setting initialValue (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8895",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8895`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/19cc2e8b55ed8817bdff66c01f4057d33799a99f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`19cc2e8`}</a>{`)`}</li>
      <li parentName="ul">{`TextArea Resize default to both (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8947",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8947`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/99879c96785fc57b2de06e99bcf45698a4bd383c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`99879c9`}</a>{`)`}</li>
      <li parentName="ul">{`TieredSelect selectableTiers false controlled value (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8871",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8871`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/0dc227b3ba34f23a1a45e0112d6ba9dd995bd0e6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`0dc227b`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-31",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-31",
        "aria-label": "features 31 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[FDN-147]`}{` JSS for Menu Component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8819",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8819`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/510af383549f83f87064d03ac91445d478df9784",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`510af38`}</a>{`)`}</li>
      <li parentName="ul">{`[FDN-429]`}{` JSS Portal (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8626",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8626`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/afae8d81da262e0ef1fc55eebcec33f3a1060605",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`afae8d8`}</a>{`)`}</li>
      <li parentName="ul">{`apply new shadow to Poppover (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/45b3c3deb53bc70cb40ac9738479c514d7596b5f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`45b3c3d`}</a>{`)`}</li>
      <li parentName="ul">{`Form Display Date TZ, Date Time Console Logging. refactor!: Remove Context Inheritance (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8891",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8891`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/591b9b7eed9f35b41b115ee4851bcf5fc16194bd",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`591b9b7`}</a>{`)`}</li>
      <li parentName="ul">{`Range Component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8643",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8643`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6ccecb51b6eeaa7eacfb838c0cdee4f6d6a57ba8",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6ccecb5`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "reverts-2",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#reverts-2",
        "aria-label": "reverts 2 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Reverts`}</h3>
    <ul>
      <li parentName="ul">{`apply new Shadow to Banner (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/346c701dc5126e049ff96c4579c1d02ac6cea1ee",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`346c701`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "1080-2021-05-07",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1080-2021-05-07",
        "aria-label": "1080 2021 05 07 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.7.0...v10.8.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.8.0`}</a>{` (2021-05-07)`}</h2>
    <h3 {...{
      "id": "bug-fixes-30",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-30",
        "aria-label": "bug fixes 30 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`clear button of table select cell does not work properly (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8782",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8782`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/635c5425e7d3c87449ddcc266604d80938d4ec28",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`635c542`}</a>{`)`}</li>
      <li parentName="ul">{`GroupedSelect, Grouped Menu Item, Disabled Menu Item Still Highlight (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8835",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8835`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d3d8f6fd9bc5d02a67dda1ef15ecfc91e287dfd7",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d3d8f6f`}</a>{`)`}</li>
      <li parentName="ul">{`Modal blinking on close (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8790",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8790`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7341e7ecb4f69125f8324848109ac2cd0772d4c9",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7341e7e`}</a>{`)`}</li>
      <li parentName="ul">{`useScroll types (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8795",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8795`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/caf1a1625a28eae0346d2d494885a2f29bcdba54",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`caf1a16`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` expose shouldScroll option on MenuImperative; turn off scroll in options update use (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6912ad5a750d0ea44e217b608a6361baef84ba9f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6912ad5`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-32",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-32",
        "aria-label": "features 32 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2828]`}{` Refactor MenuImperative to styled-components (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8432",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8432`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/cee784538147c8e878bb513629b95f4d7bd7e432",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`cee7845`}</a>{`)`}</li>
      <li parentName="ul">{`Form export BETA_makeField (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8775",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8775`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/880fddfac97b76c12e7559f538107cf0beca884f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`880fddf`}</a>{`)`}</li>
      <li parentName="ul">{`Progress Bar Prop Spread and Misc Docs (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8754",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8754`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/35c6f12132533279f02ec784f119a5847a9aa8c1",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`35c6f12`}</a>{`)`}</li>
      <li parentName="ul">{`update icons (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8798",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8798`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d96ed0d926a1f1aaa54c32ea4aca660af12567ab",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d96ed0d`}</a>{`)`}</li>
      <li parentName="ul">{`update translations for RelatedItems (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8771",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8771`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/757abcf6d72ecd740fa391baf3c8597b980c73ad",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`757abcf`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-i18n-js:`}</strong>{` Smartling translations are completed (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8761",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8761`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a2956047703d9ba74522b6d86bfcb62c978b6b64",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a295604`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` data-qa tag updates (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/58bebfbcf97711ca37b4c0646a1f763bfc7cd168",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`58bebfb`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` delete unused (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/bbb8fc13494f803fc5fae1e8d995da538ac66226",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`bbb8fc1`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` loadingMore indication, highlight correct items on navigate, search, laoding more (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ae22b0ab09dd58bf909dede5adb1c0305e4996d6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ae22b0a`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` style tweaks (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ceca49e0acf8dd580f9dee540a17b838dc74b7f7",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ceca49e`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` test updates (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ef07fa5a2f7dbec4962dbaf1bdaa4e5da9a1a562",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ef07fa5`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` update snapshots (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c98df6c0645a0f5117be92d47b9ec43851963461",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c98df6c`}</a>{`)`}</li>
      <li parentName="ul">{`[FDN-428]`}{` Refactor Form to styled-components (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8657",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8657`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7c14ab76acac4fed03067019b5cf16610e40f921",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7c14ab7`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "1070-2021-04-17",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1070-2021-04-17",
        "aria-label": "1070 2021 04 17 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.6.1...v10.7.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.7.0`}</a>{` (2021-04-17)`}</h2>
    <h3 {...{
      "id": "bug-fixes-31",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-31",
        "aria-label": "bug fixes 31 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[FDN-458]`}{` focus state increases FileToken size (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8662",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8662`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/73329f9eca8dce8c0b732552e1b0e28e39d21308",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`73329f9`}</a>{`)`}</li>
      <li parentName="ul">{`[FDN-474]`}{` Working Session Cleaning (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8710",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8710`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/421987be2fca52a4d2805c8643a3373e11b8b6b2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`421987b`}</a>{`)`}</li>
      <li parentName="ul">{`fix hooks in overlaytrigger (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8649",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8649`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/deda4305037b16db8875c45a95756f18a214a667",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`deda430`}</a>{`)`}</li>
      <li parentName="ul">{`forwarding classname to spinner container (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8615",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8615`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5a3c29cb4713e3d853741374ddeb457b6b815024",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5a3c29c`}</a>{`)`}</li>
      <li parentName="ul">{`remove FileList component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/767e72d72214dea5b3c8bde6dd06456abe4a3603",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`767e72d`}</a>{`)`}</li>
      <li parentName="ul">{`revert FileList removal (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/02b25d5d8c382f27e84d18421930d2fa4ae1f6a2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`02b25d5`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-33",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-33",
        "aria-label": "features 33 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`core-i18n-js:`}</strong>{` Smartling translations are completed (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8722",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8722`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/8b3dbdc3817c8967b10aa5275efde344c0543ac5",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`8b3dbdc`}</a>{`)`}</li>
      <li parentName="ul">{`[FDN-349]`}{` add "animated" API and convert to styled-components ProgressBar (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8569",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8569`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/156afb687ef8b195be28a23548c7b59490fb4920",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`156afb6`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2838]`}{` Refactor Search to styled-components (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8196",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8196`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f02865dccbb17c8a4b1c659bd39651153fc8b1e7",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f02865d`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-3000]`}{` Refactor DropdownFlyout to styled-components (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8613",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8613`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/29a498ade9d003063f6cf3fa4c33aa0c289973e2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`29a498a`}</a>{`)`}</li>
      <li parentName="ul">{`Date, Time, and Time Zone Formatter and Context (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7440",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7440`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/54e7552317918d2af204d5313a2e69a020b037e3",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`54e7552`}</a>{`)`}</li>
      <li parentName="ul">{`fix gridsource storybook (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8601",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8601`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/cd9fa43c0f0cad7378c0c5485700ed650d5059db",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`cd9fa43`}</a>{`)`}</li>
      <li parentName="ul">{`inputs design audit updates (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8508",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8508`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f535027fbc857741e466878fab6b3af444f329d7",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f535027`}</a>{`)`}</li>
      <li parentName="ul">{`update translations (en) for connected related items component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8696",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8696`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f93f9cafbff888b515d60add2ce392ec7b5e416d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f93f9ca`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-i18n-js:`}</strong>{` Smartling translations are completed (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8633",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8633`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/9c6be6ee319d59db51d3a8d9bb0d9a3174325967",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`9c6be6e`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "1061-2021-03-30",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1061-2021-03-30",
        "aria-label": "1061 2021 03 30 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.6.0...v10.6.1",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.6.1`}</a>{` (2021-03-30)`}</h2>
    <h3 {...{
      "id": "bug-fixes-32",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-32",
        "aria-label": "bug fixes 32 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`account for "none" on Box padding and margin (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8606",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8606`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a8d58dfb7fe369111893aca629f2dc2e85c6abf0",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a8d58df`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "1060-2021-03-30",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1060-2021-03-30",
        "aria-label": "1060 2021 03 30 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.5.0...v10.6.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.6.0`}</a>{` (2021-03-30)`}</h2>
    <h3 {...{
      "id": "bug-fixes-33",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-33",
        "aria-label": "bug fixes 33 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2963]`}{` components styling fixes and updates (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8394",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8394`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c8497448ddf576006de92ffb1ce183616cc28e4c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c849744`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2982]`}{` NumberInput displays changes internally when value is not being changed externally (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8491",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8491`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2e9c965e8d3720ac28bce0dc14be75d9defd35bf",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2e9c965`}</a>{`)`}</li>
      <li parentName="ul">{`analytics request headers typo (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/170cc76d7d0c31e13bc0339e8219db4893fde03d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`170cc76`}</a>{`)`}</li>
      <li parentName="ul">{`Calendar Disabled Dates (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8517",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8517`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/aacd993cb67afa2b4acd6e2acead436ef497f96f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`aacd993`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-34",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-34",
        "aria-label": "features 34 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2846]`}{` Tiered JSS (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8461",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8461`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/286d379a577e1a40d9c27020c5127f1f5300eb7d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`286d379`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-i18n-js:`}</strong>{` Smartling translations are completed (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8557",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8557`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/cad8e0f4ca6c3bb195e020b4b7e5c92a8ddfd4e5",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`cad8e0f`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2830]`}{` Refactor MultiSelect to styled-components (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8470",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8470`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/85024d6663aaa780aa38010cb606239ff7b1674e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`85024d6`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2833]`}{` Refactor Pagination to styled-components (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8193",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8193`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/dee2b9a49de7209a0c85b7f1854493bf25777fbb",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`dee2b9a`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2969]`}{` Table design audit updates (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8456",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8456`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/348ab7dcdc8b150246e0b3cef339cad777a494b8",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`348ab7d`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2986]`}{` TextEditor updates (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8493",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8493`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/815e6c160ad3c5cb667a9da4b8e56e4869085193",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`815e6c1`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "reverts-3",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#reverts-3",
        "aria-label": "reverts 3 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Reverts`}</h3>
    <ul>
      <li parentName="ul">{`"chore(deps): bump @tinymce/tinymce-react from 3.10.4 to 3.11.1 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8548",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8548`}</a>{`)" (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8551",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8551`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7591e2b39cb08ad05f2c31aae1276e65c3a00ecd",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7591e2b`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "1050-2021-03-15",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1050-2021-03-15",
        "aria-label": "1050 2021 03 15 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.4.0...v10.5.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.5.0`}</a>{` (2021-03-15)`}</h2>
    <h3 {...{
      "id": "bug-fixes-34",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-34",
        "aria-label": "bug fixes 34 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2968]`}{` Button fixing stateful colors and applying internal styles always (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8447",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8447`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/bc76bc80a60906e34b05573afa9c330da10b6f67",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`bc76bc8`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-35",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-35",
        "aria-label": "features 35 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2825]`}{` Refactor Input, TextArea to styled-components (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8198",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8198`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e5e724ee4e3c29c68aafa0b7edb26864975baefc",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e5e724e`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2840]`}{` Refactor Select to styled-components (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8413",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8413`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/be187fa06b55617736c4a62c4d81173461d7bbc9",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`be187fa`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2842]`}{` Refactor Tabs to styled-components (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8197",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8197`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/367a59317cea23cf4cb5e6bcc1832246be7d5381",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`367a593`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2848]`}{` Refactor Loader, Token, FileToken to styled-components (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8182",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8182`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5bf2854f6a230b6bda49f8357b7a23df8f01b6f9",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5bf2854`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2853]`}{` Refactor Box, Flex, and FlexList to styled-components (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8188",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8188`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/51f9de405e37598fe5c787424122a1e48d1232f8",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`51f9de4`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2858]`}{` converting ListPage to JSS (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8389",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8389`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/1b9700cd39aa865269ba82e29769360f8a697c02",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1b9700c`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2860]`}{` ToolHeader JSS (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8351",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8351`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a2045e1ff81beac3dd26584218897a3bdb9601b8",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a2045e1`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "1040-2021-03-10",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1040-2021-03-10",
        "aria-label": "1040 2021 03 10 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.3.0...v10.4.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.4.0`}</a>{` (2021-03-10)`}</h2>
    <h3 {...{
      "id": "bug-fixes-35",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-35",
        "aria-label": "bug fixes 35 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`fix logic for setting to current millenium (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8412",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8412`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5b3efbb326b9bfc6609e373b934126b88fe07f5d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5b3efbb`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` Form.Field tooltip traditional placement (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8220",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8220`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/0efa0a964ad7123ccb6b3e888765f3b70aed48d8",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`0efa0a9`}</a>{`)`}</li>
      <li parentName="ul">{`classname being passed through again (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8382",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8382`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d734ccfa4ca456ef2bb58058d332461ae6529e18",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d734ccf`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-36",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-36",
        "aria-label": "features 36 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2859]`}{` Sidebar as JSS (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8424",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8424`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/04aea22c4382a2048f35f75b38145696c8cf84dc",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`04aea22`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2813]`}{` Refactor Calendar to styled-components (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8181",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8181`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/79a18da594e9b7514779c189b37f18af1f8b2744",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`79a18da`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2839]`}{` Refactor SegmentedController to styled-components (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8194",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8194`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7c21df8bd7f55751ba90ef7c66e8eef074b324a1",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7c21df8`}</a>{`)`}</li>
      <li parentName="ul">{`add context hook for analytics (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3f98d3483ea3d0d94fd9014ce900873668fe58af",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3f98d34`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "1030-2021-03-02",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1030-2021-03-02",
        "aria-label": "1030 2021 03 02 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.2.0...v10.3.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.3.0`}</a>{` (2021-03-02)`}</h2>
    <h3 {...{
      "id": "bug-fixes-36",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-36",
        "aria-label": "bug fixes 36 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[Glue-2962]`}{` Add default color to P and Ul (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8369",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8369`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b04faaea5e795cffcf912ba81a7b4ba4f1b02325",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b04faae`}</a>{`)`}</li>
      <li parentName="ul">{`Button prop loading is html disabled. Dropdown loading does not open (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8320",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8320`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/598a5057133344010ebd1e9ac09e4ee29d019285",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`598a505`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7690",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7690`}</a></li>
      <li parentName="ul">{`DropdownFlyout default variant aligns with Dropdown, secondary (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8352",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8352`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6cdc208e31a92a48a824f6291b15e352c689d2bd",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6cdc208`}</a>{`)`}</li>
      <li parentName="ul">{`make text editor react to initialValue changes (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/da199bbd3a8a8e820e8eb2af0a1209141b4dda33",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`da199bb`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-37",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-37",
        "aria-label": "features 37 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2818]`}{` Refactor DateInput to styled-components (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8238",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8238`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b1bd5e68405fc9c2d1170bf8b5085d3ff6a3e4c2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b1bd5e6`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2819]`}{` Refactor Dropdown to styled-components (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8218",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8218`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/0c28cdf0ed39386cf5de535845d88e37950001b7",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`0c28cdf`}</a>{`)`}</li>
      <li parentName="ul">{`add FileSelect#uploadFile API for imperative file upload (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8211",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8211`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/4486e4689191b78c6bdbd95b3ca4540680593e2b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`4486e46`}</a>{`)`}</li>
      <li parentName="ul">{`Dropdown defaults to EllipsisVertical icon when no label nor icon prop passed (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8219",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8219`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e0d21676a43ca8442d0c8b44c3bb4785366088eb",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e0d2167`}</a>{`)`}</li>
      <li parentName="ul">{`DropdownFlyout like Dropdown with variant, label, icon, size, disabled props (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8319",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8319`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c477a180fc0a54e6a2c390da4c4fc1bde506c721",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c477a18`}</a>{`)`}</li>
      <li parentName="ul">{`Smartling translations are completed (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8349",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8349`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/8a0b7ee45ea4c22365ca01e6566a55a9f1930777",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`8a0b7ee`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "1020-2021-02-19",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1020-2021-02-19",
        "aria-label": "1020 2021 02 19 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.1.0...v10.2.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.2.0`}</a>{` (2021-02-19)`}</h2>
    <h3 {...{
      "id": "bug-fixes-37",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-37",
        "aria-label": "bug fixes 37 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`actually clear tiered select when manually setting value to [] (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8209",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8209`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/0b8231e84d3cdc055143faf7306a5db2d7dc1104",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`0b8231e`}</a>{`)`}</li>
      <li parentName="ul">{`passing type through button (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8208",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8208`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/cbff93f4bdd33d0893ac52931c3183f0c0b2c4df",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`cbff93f`}</a>{`)`}</li>
      <li parentName="ul">{`RadioButton with empty child, Checkbox typography (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8214",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8214`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/cbb241a527958a38ea29f1002588421f703eef5b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`cbb241a`}</a>{`)`}</li>
      <li parentName="ul">{`spacing import in EmptyState styles (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8199",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8199`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/582e48847e7610bca709df15ddddb6210a5f2f34",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`582e488`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-38",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-38",
        "aria-label": "features 38 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2821]`}{` Refactor EmptyState to styled-components (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8159",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8159`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/1793361412d02cd9619f9e31b166a24ee6cf864f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1793361`}</a>{`)`}</li>
      <li parentName="ul">{`add translations (en) for connected related items component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8201",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8201`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/62ff7ed24637ea3c5a2b3d034fad50d8c37cbbf3",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`62ff7ed`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "1010-2021-02-12",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1010-2021-02-12",
        "aria-label": "1010 2021 02 12 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.0.1...v10.1.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.1.0`}</a>{` (2021-02-12)`}</h2>
    <h3 {...{
      "id": "bug-fixes-38",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-38",
        "aria-label": "bug fixes 38 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Detail Page Section when Empty Content (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8183",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8183`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2bd813a00c6e1908f1c9146f92a35f4629f0045c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2bd813a`}</a>{`)`}</li>
      <li parentName="ul">{`exporting colors (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8187",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8187`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/434a6a998c2269207291fc0147a3e7f859165b68",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`434a6a9`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-39",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-39",
        "aria-label": "features 39 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Smartling translations are completed (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8186",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8186`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3aeee12cb1ddb8a587544a2a7810fe417eb22268",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3aeee12`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "1001-2021-02-10",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1001-2021-02-10",
        "aria-label": "1001 2021 02 10 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v10.0.0...v10.0.1",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.0.1`}</a>{` (2021-02-10)`}</h2>
    <h3 {...{
      "id": "bug-fixes-39",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-39",
        "aria-label": "bug fixes 39 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`fix ContactItem layout in IE (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8129",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8129`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/cdb2e74ed4a2fcc4f0dbdc960fcc11646f174259",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`cdb2e74`}</a>{`)`}</li>
      <li parentName="ul">{`panel component back button visibility (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8146",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8146`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/fb058d7a5445b9cef4468caf13a8244cda5d3bd3",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`fb058d7`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "1000-2021-02-09",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1000-2021-02-09",
        "aria-label": "1000 2021 02 09 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v9.9.0...v10.0.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`10.0.0`}</a>{` (2021-02-09)`}</h2>
    <h3 {...{
      "id": "bug-fixes-40",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-40",
        "aria-label": "bug fixes 40 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`adding font-family: inherit to typography (`}<a parentName="p" {...{
            "href": "https://github.com/procore/core/issues/8139",
            "target": "_blank",
            "rel": "nofollow noopener noreferrer"
          }}>{`#8139`}</a>{`) (`}<a parentName="p" {...{
            "href": "https://github.com/procore/core/commit/cb9ad2d909924be005108bf043915a6ec2b5fa31",
            "target": "_blank",
            "rel": "nofollow noopener noreferrer"
          }}>{`cb9ad2d`}</a>{`)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`aligning tokens in multiselect (`}<a parentName="p" {...{
            "href": "https://github.com/procore/core/issues/8140",
            "target": "_blank",
            "rel": "nofollow noopener noreferrer"
          }}>{`#8140`}</a>{`) (`}<a parentName="p" {...{
            "href": "https://github.com/procore/core/commit/d866451902ee3f18ac5cf7a75d28803635c7f64d",
            "target": "_blank",
            "rel": "nofollow noopener noreferrer"
          }}>{`d866451`}</a>{`)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`dont show dropdown arrow on banner actions overflow (`}<a parentName="p" {...{
            "href": "https://github.com/procore/core/commit/9b5f097787b2642039bb38046229411e765045e9",
            "target": "_blank",
            "rel": "nofollow noopener noreferrer"
          }}>{`9b5f097`}</a>{`)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`fix icon usage and table group header font weight (`}<a parentName="p" {...{
            "href": "https://github.com/procore/core/commit/94165ee77ddde04937ab8010f7148e19ad1a8ccb",
            "target": "_blank",
            "rel": "nofollow noopener noreferrer"
          }}>{`94165ee`}</a>{`)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`revert line-height changes on numberinput, disable tabindex (`}<a parentName="p" {...{
            "href": "https://github.com/procore/core/issues/8150",
            "target": "_blank",
            "rel": "nofollow noopener noreferrer"
          }}>{`#8150`}</a>{`) (`}<a parentName="p" {...{
            "href": "https://github.com/procore/core/commit/d32e42c66f392be8047e6e1e3ba52c0bb0646a6e",
            "target": "_blank",
            "rel": "nofollow noopener noreferrer"
          }}>{`d32e42c`}</a>{`)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`unit test updates (`}<a parentName="p" {...{
            "href": "https://github.com/procore/core/issues/8137",
            "target": "_blank",
            "rel": "nofollow noopener noreferrer"
          }}>{`#8137`}</a>{`) (`}<a parentName="p" {...{
            "href": "https://github.com/procore/core/commit/740df507b5e6e6940901f693bceea14c3a4197e6",
            "target": "_blank",
            "rel": "nofollow noopener noreferrer"
          }}>{`740df50`}</a>{`)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`V10 Form Icon Alignment and Traditional Label, Thumbnail Label ellipsis, DateSelect Height (`}<a parentName="p" {...{
            "href": "https://github.com/procore/core/issues/8160",
            "target": "_blank",
            "rel": "nofollow noopener noreferrer"
          }}>{`#8160`}</a>{`) (`}<a parentName="p" {...{
            "href": "https://github.com/procore/core/commit/cd807c1638b126e89e20792dd2d47cbfb579500a",
            "target": "_blank",
            "rel": "nofollow noopener noreferrer"
          }}>{`cd807c1`}</a>{`)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`v10 Semantic color reference (`}<a parentName="p" {...{
            "href": "https://github.com/procore/core/issues/8104",
            "target": "_blank",
            "rel": "nofollow noopener noreferrer"
          }}>{`#8104`}</a>{`) (`}<a parentName="p" {...{
            "href": "https://github.com/procore/core/commit/01bced8189f8aab02948afcecab5445a08bc6328",
            "target": "_blank",
            "rel": "nofollow noopener noreferrer"
          }}>{`01bced8`}</a>{`)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`feat!: DetailPage width XL (#8154) (`}<a parentName="p" {...{
            "href": "https://github.com/procore/core/commit/60ee6bd4fb55a31108b3db17ef33935d00b3bf00",
            "target": "_blank",
            "rel": "nofollow noopener noreferrer"
          }}>{`60ee6bd`}</a>{`), closes `}<a parentName="p" {...{
            "href": "https://github.com/procore/core/issues/8154",
            "target": "_blank",
            "rel": "nofollow noopener noreferrer"
          }}>{`#8154`}</a></p>
      </li>
    </ul>
    <h3 {...{
      "id": "features-40",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-40",
        "aria-label": "features 40 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[Glue 2557]`}{` Input Heights Scss (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7996",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7996`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5b8c6216c48c2fec36d2e4cb152487c5a8732680",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5b8c621`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2668]`}{` Removing Font (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7917",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7917`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/01b040faa3ae8c279d9e7d5c6e7d0b74e5b099d2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`01b040f`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2909]`}{` Swapping in Button Next component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8048",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8048`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6b81a9f08a0b3a9819647753f4b3d0593e8623e2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6b81a9f`}</a>{`)`}</li>
      <li parentName="ul">{`Swap clickable Icon with Button (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8106",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8106`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d20324f7afceea23f8596a20a58a11e6ea3d3311",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d20324f`}</a>{`)`}</li>
      <li parentName="ul">{`update icons (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8115",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8115`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ff1302abd3d0334da8951074ccf70e9d30778cf0",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ff1302a`}</a>{`)`}</li>
      <li parentName="ul">{`update icons (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8147",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8147`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a2e276be3d834c41a506c82af5784ae4ff0b0b75",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a2e276b`}</a>{`)`}</li>
      <li parentName="ul">{`update year logic on DateInput to support 2 digit years (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8148",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8148`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/fce4d1b650ba00b1906d88a60d7b489e5ce0fb76",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`fce4d1b`}</a>{`)`}</li>
      <li parentName="ul">{`V10 Banner and Toast Icons (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8110",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8110`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/1cca9e21a8737664c01b96258b729ef6b320a035",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1cca9e2`}</a>{`)`}</li>
      <li parentName="ul">{`version 10 tweaks (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8138",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8138`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/acddb05b886fdc8c22fa67ad59574d26f74d4f55",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`acddb05`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "breaking-changes-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#breaking-changes-1",
        "aria-label": "breaking changes 1 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`BREAKING CHANGES`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`width 1440 is now xl, not lg`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Deprecations|`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`chore: update spacing for detail page section header actions`}</p>
      </li>
    </ul>
    <p>{`affects: @procore/core-css`}</p>
    <ul>
      <li parentName="ul">{`chore: add deprecation notices`}</li>
    </ul>
    <p>{`affects: @procore/core-react`}</p>
    <ul>
      <li parentName="ul">{`chore: add default export back to Notation`}</li>
    </ul>
    <p>{`affects: @procore/core-react`}</p>
    <ul>
      <li parentName="ul">{`chore: remove unused tsconfig`}</li>
    </ul>
    <p>{`affects: @procore/core-react`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      